import React, { useEffect, useState, useRef } from 'react'
import GoldSiverHeader from './GoldSiverHeader'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { getPlayerPokemons, getPokemonsByPlayer } from '../../store/pokemon'
import { Tooltip } from 'react-tooltip'
import { Badge, Button, Modal } from 'react-bootstrap'
import EvolutionAnimation from '../../components/EvolutionAnimation'
import LearnAttackModal from '../Component/LearnAttackModal'
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom'
import axiosInstance from '../../api/axios'
import { API_ENDPOINTS } from '../../api/endpoint'
import { dualExpire, getDualByTrainerId } from 'store/friends'
import { doAttck, getAttckLogs } from 'store/battle'
import { toast } from 'react-toastify'
import { getProfile } from '../../store/auth'
import { useTranslation } from 'react-i18next'
import i18n from '../../i18n'
import { getBattleSettings } from '../../store/battleSettings'

// משתנה סטטי מחוץ לקומפוננטה לזיהוי האם יש קרב פעיל כרגע
let activeBattleInstance = null;

function Battle() {
    const { t } = useTranslation();
    const currentLanguage = i18n.language || 'en';
    const isRTL = currentLanguage === 'he';

    // יצירת מזהה ייחודי לקרב נוכחי
    const battleInstanceId = useRef(Date.now().toString());
    
    // Track if battle finish was already called to prevent duplicate calls
    const battleFinishCalled = useRef(false);
    // Track original URL to prevent changes during battle
    const originalURLRef = useRef(null);
    
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    const duel = searchParams.get('duel')
    const challanged = searchParams.get('challanged')
    const mapType = searchParams.get('map')
    const gebied = searchParams.get('gebied')
    const isTrainerBattle = searchParams.get('trainer') === 'true'
    const trainerBattleId = searchParams.get('battle_id')

    const isMapBattle = !!mapType || isTrainerBattle;

    const pokemons = useSelector(state => state.pokemon.player_pokemons)
    const battleSettings = useSelector(state => state.battleSettings.settings)
    const [yourPokemon, setYourPokemon] = useState({})
    const [oppPokemon, setOppPokemon] = useState({})
    // Track all Pokemon that participated in battle (for HP updates)
    const [battlePokemons, setBattlePokemons] = useState([])
    const [attacking, setAttacking] = useState(false)
    const [oppAttacking, setOppAttacking] = useState(false)
    const [currentAttack, setCurrentAttack] = useState({})
    const [type, setType] = useState('Attack')
    const [winLose, setWinLose] = useState('')
    // משתנה לניהול התורות
    const [isPlayerTurn, setIsPlayerTurn] = useState(true)
    // משתנה לאחסון פריטים מהתיק
    const [pokeballs, setPokeballs] = useState([])
    const [potions, setPotions] = useState([])
    const [otherItems, setOtherItems] = useState([])
    const [allItems, setAllItems] = useState([])
    const [loadingPokeballs, setLoadingPokeballs] = useState(false)
    // משתנה לאנימציית זריקת כדור
    const [throwingBall, setThrowingBall] = useState(false)
    const [ballCaught, setBallCaught] = useState(false)
    const [currentBall, setCurrentBall] = useState(null) // הכדור הנוכחי שנזרק
    // שלב הלכידה: 'throwing' | 'capturing' | 'shaking' | 'caught' | 'escaping' | null
    const [capturePhase, setCapturePhase] = useState(null)
    // אפקט רעידת מסך להתקפות חזקות
    const [screenShake, setScreenShake] = useState(false)
    // משתנה למניעת יציאה אוטומטית מהקרב
    const [battleActive, setBattleActive] = useState(false)
    // משתנה למעקב אחרי זמן מאז הפעולה האחרונה
    const [lastActionTime, setLastActionTime] = useState(Date.now())
    // State for evolution popup
    const [showEvolutionModal, setShowEvolutionModal] = useState(false)
    const [evolutionData, setEvolutionData] = useState(null)
    const [showEvolutionAnimation, setShowEvolutionAnimation] = useState(false)
    // State for learn new attack popup - initialize from localStorage if available
    const [showLearnAttackModal, setShowLearnAttackModal] = useState(() => {
        const saved = localStorage.getItem('pendingAttackData');
        return saved ? true : false;
    })
    const [pendingAttackData, setPendingAttackData] = useState(() => {
        const saved = localStorage.getItem('pendingAttackData');
        if (saved) {
            console.log('[LEARN ATTACK] Loaded from localStorage:', saved);
            return JSON.parse(saved);
        }
        return null;
    })
    // משתנה לאבטחת ניווט ומניעת יציאות אוטומטיות
    const [navigationLocked, setNavigationLocked] = useState(true);
    // טיימר לקרב - 3 דקות (180 שניות)
    const [battleTimer, setBattleTimer] = useState(180); // 3 minutes in seconds
    const [battleStartTime, setBattleStartTime] = useState(null);
    // מצב טעינה - מראה ספינר במקום תמונות דיפולטיביות
    const [isLoading, setIsLoading] = useState(true);
    // מצב לאפקט מעבר בין פוקימונים
    const [pokemonSwitching, setPokemonSwitching] = useState(false);

    const [playerEffects, setPlayerEffects] = useState({
        status: null,
        statusTurns: 0,
        statChanges: { attack: 0, defense: 0, speed: 0, sp_attack: 0, sp_defense: 0, accuracy: 0, evasion: 0 },
        confusion: 0,
        flinch: false
    });
    const [opponentEffects, setOpponentEffects] = useState({
        status: null,
        statusTurns: 0,
        statChanges: { attack: 0, defense: 0, speed: 0, sp_attack: 0, sp_defense: 0, accuracy: 0, evasion: 0 },
        confusion: 0,
        flinch: false
    });
    const [attackDataCache, setAttackDataCache] = useState({});

    const dispatch = useDispatch()
    const navigateHook = useNavigate();
    
    // פונקציית ניווט מוגנת - הגנה: מניעת ניווט אם יש קרב פעיל
    const navigate = (path) => {
        // בדיקה אם יש קרב פעיל ב-localStorage
        const savedBattleState = localStorage.getItem('activeBattle');
        if (savedBattleState) {
            try {
                const battleState = JSON.parse(savedBattleState);
                if (battleState.battleActive && !battleState.winLose) {
                    console.log("⛔ Navigation blocked - active battle in localStorage");
                    toast.warning(t('Cannot exit an active battle! Win or lose to finish.'));
                    return;
                }
            } catch (e) {
                // אם יש שגיאה, אפשר ניווט
            }
        }
        
        // בדיקה אם יש קרב פעיל במצב הנוכחי
        if (battleActive && !winLose) {
            console.log("⛔ Navigation blocked - active battle in state");
            toast.warning(t('Cannot exit an active battle! Win or lose to finish.'));
            return;
        }
        
        // אם הכל בסדר, אפשר ניווט
        navigateHook(path);
    }
    const [name, setName] = useState('')
    const [oppName, setOppName] = useState('')
    const [ws, setWs] = useState(null);

    const [user, setUser] = useState({ name: '', pokemons: [] });
    const [opponent, setOpponent] = useState({ name: '', pokemons: [] });
    const [duel_data, setDuelData] = useState({});
    
    // Trainer battle state
    const [trainerBattleData, setTrainerBattleData] = useState(null);
    const [trainerPokemonList, setTrainerPokemonList] = useState([]);
    const [currentTrainerPokemonIndex, setCurrentTrainerPokemonIndex] = useState(0);
    const [trainerName, setTrainerName] = useState('');
    const [trainerImage, setTrainerImage] = useState('');
    const [trainerBattleCountdown, setTrainerBattleCountdown] = useState(null);

    // משתנה שיעקוב אחרי אם הקרב כבר נוצר
    const battleInitialized = useRef(false);
    // משתנה שיעקוב אחרי אם היתה יציאה מרצון מהקרב
    const manualExit = useRef(false);
    // משתנה שיעקוב אחרי האם זה האתחול הראשוני
    const isFirstLoad = useRef(true);

    // עודכן משתנה לשליטה ביכולת לצאת מהקרב
    const [userAllowedToExit, setUserAllowedToExit] = useState(false);
    // משתנה לחסימת מעבר אוטומטי כשהקומפוננטה רק נטענת
    const componentMounted = useRef(false);

    // יצירת מנגנון לחסימת ניווטים לא רצויים - הגנה 2: אי אפשר לצאת מהעמוד עד שהקרב מסתיים
    useEffect(() => {
        // בדיקה אם יש קרב פעיל ב-localStorage
        const checkActiveBattle = () => {
            const savedBattleState = localStorage.getItem('activeBattle');
            if (savedBattleState) {
                try {
                    const battleState = JSON.parse(savedBattleState);
                    return battleState.battleActive && !battleState.winLose;
                } catch (e) {
                    return false;
                }
            }
            return false;
        };
        
        // מונע יציאה תוך כדי קרב פעיל
        const preventNavigation = (e) => {
            const hasActiveBattle = battleActive && !winLose;
            const hasSavedActiveBattle = checkActiveBattle();
            
            if (hasActiveBattle || hasSavedActiveBattle) {
                // מניעת רענון עמוד
                e.preventDefault();
                e.returnValue = t('Cannot exit an active battle! Win or lose to finish.');
                return e.returnValue;
            }
        };
        
        // מניעת רענון עמוד
        window.addEventListener('beforeunload', preventNavigation);
        
        // מניעת ניווט אחורה/קדימה
        const handlePopState = (e) => {
            const hasActiveBattle = battleActive && !winLose;
            const hasSavedActiveBattle = checkActiveBattle();
            
            if (hasActiveBattle || hasSavedActiveBattle) {
                // שחזור המצב הקודם
                window.history.pushState(null, '', window.location.href);
                toast.warning(t('Cannot exit an active battle! Win or lose to finish.'));
            }
        };
        
        window.history.pushState(null, '', window.location.href);
        window.addEventListener('popstate', handlePopState);
        
        // Update original URL when battle starts
        if (battleActive && !winLose && !originalURLRef.current) {
            originalURLRef.current = window.location.href;
        }
        
        // Reset original URL when battle ends
        if (winLose) {
            originalURLRef.current = null;
        }
        
        // Prevent URL changes during active battle
        const checkURLChange = () => {
            if (battleActive && !winLose && originalURLRef.current) {
                const currentURL = window.location.href;
                // Check if URL changed (excluding hash changes)
                const currentURLNoHash = currentURL.split('#')[0];
                const originalURLNoHash = originalURLRef.current.split('#')[0];
                
                if (currentURLNoHash !== originalURLNoHash) {
                    // Restore original URL
                    window.history.replaceState(null, '', originalURLRef.current);
                    toast.warning(t('Cannot change URL during an active battle!'));
                }
            }
        };
        
        // Check URL changes periodically
        const urlCheckInterval = setInterval(checkURLChange, 100);
        
        return () => {
            window.removeEventListener('beforeunload', preventNavigation);
            window.removeEventListener('popstate', handlePopState);
            clearInterval(urlCheckInterval);
        };
    }, [battleActive, winLose, t]);
    
    // ביטול קוד שמבטל את הנעילה אוטומטית לאחר זמן מה
    // useEffect(() => {
    //     console.log("🔒 Setting navigation lock timeout");
    //     const unlockTimer = setTimeout(() => {
    //         console.log("🔓 Navigation lock timeout completed");
    //         setNavigationLocked(false);
    //     }, 5000);
    //     
    //     return () => {
    //         clearTimeout(unlockTimer);
    //     };
    // }, []);

    const getDualData = async () => {
        let user = localStorage.getItem('userData')
        user = user ? JSON.parse(user) : {}
        let payload = {
            trainer_id: user.playerId,
        }
        
        // If it's explicitly a map battle, don't try to load duel data
        if (isMapBattle) {
            return;
        }
        
        try {
            let data = await dispatch(getDualByTrainerId(payload)).unwrap();
            
            // בדיקה האם יש נתוני דו-קרב תקינים
            if (!data?.duel_data?.id) {
                console.log("דו-קרב לא קיים, אך לא יוצאים אוטומטית מהקרב אם כבר הוכנס למצב");
                
                // Instead of navigating away, let's treat this as a map battle
                if (!battleActive && !battleInitialized.current) {
                    console.log("👾 Falling back to map battle mode since no duel exists");
                    // Set map battle flag
                    const newParams = new URLSearchParams(searchParams);
                    newParams.set('map', 'true');
                    setSearchParams(newParams);
                    return;
                }
                return;
            }
            
            let user_pokemon = [];
            let opponent_pokemon = [];

            if (challanged == 'true' && data?.duel_data?.id) {
                user_pokemon = await dispatch(getPokemonsByPlayer(data?.duel_data?.uitdager)).unwrap()
                opponent_pokemon = await dispatch(getPokemonsByPlayer(data?.duel_data?.tegenstander)).unwrap()
                
                // שמירה של נקודות חיים מקוריות וטיפול טוב יותר במספרים
                if (opponent_pokemon?.data) {
                    opponent_pokemon.data.map((item)=>{
                        // המרה לשלמים
                        item.leven = parseInt(item.leven) || 100;
                        item.levenmax = parseInt(item.levenmax) || item.leven || 100;
                        // ודא שנקודות החיים הם מלאים בתחילת הקרב
                        item.leven = item.levenmax;
                        // שמירת העתק
                        item.origina_level = JSON.parse(JSON.stringify(item.leven));
                        return item;
                    })
                }
                
                if (user_pokemon?.data) {
                    user_pokemon.data.map((item)=>{
                        // המרה לשלמים
                        item.leven = parseInt(item.leven) || 100;
                        item.levenmax = parseInt(item.levenmax) || item.leven || 100;
                        // ודא שנקודות החיים הם מלאים בתחילת הקרב
                        item.leven = item.levenmax;
                        // שמירת העתק
                        item.origina_level = JSON.parse(JSON.stringify(item.leven));
                        return item;
                    })
                }

                // רק אם יש מידע תקין, עדכן את המצב
                if (user_pokemon?.data?.length > 0 && opponent_pokemon?.data?.length > 0) {
                    setUser({ name: data?.duel_data?.uitdager, pokemons: user_pokemon?.data })
                    setOpponent({ name: data?.duel_data?.tegenstander, pokemons: opponent_pokemon?.data })
                    setYourPokemon(user_pokemon?.data[0] || {})
                    setOppPokemon(opponent_pokemon?.data[0] || {})
                }
            } else if (data) {
                user_pokemon = await dispatch(getPokemonsByPlayer(data?.duel_data?.tegenstander)).unwrap()
                opponent_pokemon = await dispatch(getPokemonsByPlayer(data?.duel_data?.uitdager)).unwrap()

                // שמירה של נקודות חיים מקוריות וטיפול טוב יותר במספרים
                if (opponent_pokemon?.data) {
                    opponent_pokemon.data.map((item)=>{
                        // המרה לשלמים
                        item.leven = parseInt(item.leven) || 100;
                        item.levenmax = parseInt(item.levenmax) || item.leven || 100;
                        // ודא שנקודות החיים הם מלאים בתחילת הקרב
                        item.leven = item.levenmax;
                        // שמירת העתק
                        item.origina_level = JSON.parse(JSON.stringify(item.leven));
                        return item;
                    })
                }
                
                if (user_pokemon?.data) {
                    user_pokemon.data.map((item)=>{
                        // המרה לשלמים
                        item.leven = parseInt(item.leven) || 100;
                        item.levenmax = parseInt(item.levenmax) || item.leven || 100;
                        // ודא שנקודות החיים הם מלאים בתחילת הקרב
                        item.leven = item.levenmax;
                        // שמירת העתק
                        item.origina_level = JSON.parse(JSON.stringify(item.leven));
                        return item;
                    })
                }
                
                // רק אם יש מידע תקין, עדכן את המצב
                if (user_pokemon?.data?.length > 0 && opponent_pokemon?.data?.length > 0) {
                    setUser({ name: data?.duel_data?.tegenstander, pokemons: user_pokemon?.data })
                    setOpponent({ name: data?.duel_data?.uitdager, pokemons: opponent_pokemon?.data })
                    setYourPokemon(user_pokemon?.data[0] || {})
                    setOppPokemon(opponent_pokemon?.data[0] || {})
                }
            }
            
            // שמירת מידע הדו-קרב רק אם יש מידע תקין
            if (data?.duel_data?.id) {
                setDuelData(data || {})
            }
        } catch (error) {
            console.error("שגיאה בטעינת נתוני הקרב:", error);
            // אם הקרב כבר פעיל, אל תנווט החוצה במקרה של שגיאה
            if (!battleActive || !battleInitialized.current) {
                toast.error(t('Error loading battle data'));
            }
        }
    }

    // התקפות מאותחלות ריקות - יתמלאו לפי ההתקפות האמיתיות של הפוקימון
    const [attackList, setAttackList] = useState([])
    
    // פונקציה לעדכון התקפות לפי הפוקימון הנוכחי - משתמשת בהתקפות האמיתיות של הפוקימון
    const updateAttacksForPokemon = (pokemon) => {
        if (!pokemon || !pokemon.level) return;
        
        // קבלת נתוני הכוח וההתקפה של הפוקימון הנוכחי
        const pokemonAttack = parseInt(pokemon.attack || pokemon['attack'] || 50);
        const pokemonSpAttack = parseInt(pokemon['spc.attack'] || pokemon['spc.attack'] || 50);
        const pokemonLevel = parseInt(pokemon.level || 5);
        const pokemonType1 = pokemon.type1 || "Normal";
        const pokemonType2 = pokemon.type2 || null;
        
        // חישוב הכוח הבסיסי - ממוצע של attack ו-spc.attack
        const basePower = Math.floor((pokemonAttack + pokemonSpAttack) / 2);
        
        // הכפלת הכוח ב-2 כפי שביקש המשתמש
        const doubledPower = basePower * 2;
        
        // 🎯 קבלת ההתקפות האמיתיות של הפוקימון מהדאטאבייס
        const realAttacks = [
            pokemon.aanval_1 || pokemon['aanval_1'],
            pokemon.aanval_2 || pokemon['aanval_2'],
            pokemon.aanval_3 || pokemon['aanval_3'],
            pokemon.aanval_4 || pokemon['aanval_4']
        ].filter(attack => attack && attack.trim() !== ''); // סינון התקפות ריקות
        
        console.log("🔍 Pokemon real attacks from DB:", realAttacks);
        
        // פונקציה לנחש את הסוג של התקפה לפי השם
        const guessAttackType = (attackName, index) => {
            if (!attackName) return pokemonType1;
            
            const name = attackName.toLowerCase();
            
            // התקפות אש
            if (name.includes('fire') || name.includes('flame') || name.includes('burn') || name.includes('ember') || name.includes('blaze') || name.includes('heat') || name.includes('inferno')) return 'Fire';
            // התקפות מים
            if (name.includes('water') || name.includes('aqua') || name.includes('hydro') || name.includes('surf') || name.includes('wave') || name.includes('rain') || name.includes('bubble') || name.includes('splash')) return 'Water';
            // התקפות חשמל
            if (name.includes('thunder') || name.includes('electric') || name.includes('shock') || name.includes('spark') || name.includes('volt') || name.includes('lightning') || name.includes('zap')) return 'Electric';
            // התקפות דשא
            if (name.includes('grass') || name.includes('leaf') || name.includes('vine') || name.includes('razor') || name.includes('solar') || name.includes('seed') || name.includes('petal') || name.includes('bloom')) return 'Grass';
            // התקפות קרח
            if (name.includes('ice') || name.includes('freeze') || name.includes('blizzard') || name.includes('frost') || name.includes('cold') || name.includes('snow') || name.includes('hail')) return 'Ice';
            // התקפות קרב
            if (name.includes('punch') || name.includes('kick') || name.includes('chop') || name.includes('karate') || name.includes('fight') || name.includes('brick') || name.includes('focus') || name.includes('close combat')) return 'Fighting';
            // התקפות רעל
            if (name.includes('poison') || name.includes('toxic') || name.includes('acid') || name.includes('sludge') || name.includes('venom')) return 'Poison';
            // התקפות קרקע
            if (name.includes('ground') || name.includes('earth') || name.includes('quake') || name.includes('dig') || name.includes('mud') || name.includes('sand')) return 'Ground';
            // התקפות עפיפה
            if (name.includes('fly') || name.includes('aerial') || name.includes('wing') || name.includes('air') || name.includes('gust') || name.includes('sky') || name.includes('brave bird')) return 'Flying';
            // התקפות פסיכי
            if (name.includes('psych') || name.includes('confusion') || name.includes('hypnosis') || name.includes('dream') || name.includes('zen') || name.includes('future') || name.includes('extrasensory')) return 'Psychic';
            // התקפות באג
            if (name.includes('bug') || name.includes('pin') || name.includes('leech') || name.includes('string') || name.includes('x-scissor') || name.includes('fury cutter')) return 'Bug';
            // התקפות סלע
            if (name.includes('rock') || name.includes('stone') || name.includes('ancient') || name.includes('rollout') || name.includes('stealth')) return 'Rock';
            // התקפות רוח
            if (name.includes('ghost') || name.includes('shadow') || name.includes('curse') || name.includes('night') || name.includes('hex') || name.includes('phantom')) return 'Ghost';
            // התקפות דרקון
            if (name.includes('dragon') || name.includes('draco') || name.includes('outrage') || name.includes('twister')) return 'Dragon';
            // התקפות חושך
            if (name.includes('dark') || name.includes('bite') || name.includes('crunch') || name.includes('foul') || name.includes('sucker') || name.includes('night slash')) return 'Dark';
            // התקפות מתכת
            if (name.includes('steel') || name.includes('iron') || name.includes('metal') || name.includes('flash cannon') || name.includes('bullet')) return 'Steel';
            // התקפות פיות
            if (name.includes('fairy') || name.includes('moonblast') || name.includes('dazzling') || name.includes('play rough') || name.includes('draining kiss')) return 'Fairy';
            
            // אם לא מצאנו התאמה, נשתמש בסוג הפוקימון
            // התקפה ראשונה - סוג ראשון, שנייה - סוג שני (אם קיים), השאר - סוג ראשון
            if (index === 1 && pokemonType2) return pokemonType2;
            return pokemonType1;
        };
        
        // יצירת רשימת התקפות מההתקפות האמיתיות
        const newAttacks = [];
        
        if (realAttacks.length > 0) {
            // יש התקפות אמיתיות - נשתמש בהן
            realAttacks.forEach((attackName, index) => {
                if (attackName) {
                    const attackType = guessAttackType(attackName, index);
                    // כוח התקפה לפי מיקום - ההתקפה הראשונה חלשה יותר, האחרונה חזקה יותר
                    const powerMultiplier = 0.6 + (index * 0.15); // 0.6, 0.75, 0.9, 1.05
                    const minDmg = Math.floor(basePower * powerMultiplier);
                    const maxDmg = Math.floor(doubledPower * powerMultiplier);
                    
                    newAttacks.push({
                        name: attackName,
                        minDamage: minDmg,
                        maxDamage: maxDmg,
                        type: attackType
                    });
                }
            });
        }
        
        // בדיקת הגדרות קרב - האם להציג התקפות ברירת מחדל
        const showDefaultAttacks = battleSettings?.show_default_attacks === '1';
        const targetAttackCount = parseInt(battleSettings?.default_attacks_count || '4');
        
        // אם צריך להציג התקפות ברירת מחדל
        if (showDefaultAttacks && newAttacks.length < targetAttackCount) {
            const defaultAttacks = [
                { name: 'Tackle', type: 'Normal' },
                { name: 'Scratch', type: 'Normal' },
                { name: `${pokemonType1} Attack`, type: pokemonType1 },
                { name: pokemonType2 ? `${pokemonType2} Attack` : 'Quick Attack', type: pokemonType2 || 'Normal' }
            ];
            
            while (newAttacks.length < targetAttackCount) {
                const defaultAtk = defaultAttacks[newAttacks.length % defaultAttacks.length];
                newAttacks.push({
                    name: defaultAtk.name,
                    minDamage: basePower,
                    maxDamage: Math.floor(doubledPower * (0.6 + newAttacks.length * 0.15)),
                    type: defaultAtk.type
                });
            }
        } else if (newAttacks.length === 0) {
            // רק אם אין בכלל התקפות, נוסיף התקפה בסיסית אחת (Tackle)
            // כדי שלפוקימון תהיה לפחות התקפה אחת
            newAttacks.push({
                name: 'Tackle',
                minDamage: basePower,
                maxDamage: doubledPower,
                type: 'Normal'
            });
        }
        
        // הגבלה ל-4 התקפות מקסימום
        const finalAttacks = newAttacks.slice(0, 4);
        
        // עדכון רשימת ההתקפות
        setAttackList(finalAttacks);
        console.log("🔄 Updated attacks for Pokemon:", pokemon.naam, "Level:", pokemonLevel, "Base Power:", basePower, "Real Attacks:", realAttacks, "Final Attacks:", finalAttacks);
        
        fetchAttackData(finalAttacks.map(a => a.name));
    }

    const fetchAttackData = async (attackNames) => {
        const uncached = attackNames.filter(name => !attackDataCache[name]);
        if (uncached.length === 0) return;
        
        try {
            const response = await axiosInstance.get('/api/api/getAttackInfo.php', {
                params: { names: uncached.join(',') }
            });
            if (response.data.success) {
                setAttackDataCache(prev => ({ ...prev, ...response.data.attacks }));
            }
        } catch (error) {
            console.log("Could not fetch attack data:", error.message);
        }
    };

    const getStatMultiplier = (stages) => {
        const multipliers = { '-6': 0.25, '-5': 0.29, '-4': 0.33, '-3': 0.4, '-2': 0.5, '-1': 0.67, '0': 1, '1': 1.5, '2': 2, '3': 2.5, '4': 3, '5': 3.5, '6': 4 };
        return multipliers[String(Math.max(-6, Math.min(6, stages)))] || 1;
    };

    const applyStatChange = (isPlayer, stat, stages) => {
        const setter = isPlayer ? setPlayerEffects : setOpponentEffects;
        const targetName = isPlayer ? yourPokemon?.naam : oppPokemon?.naam;
        
        setter(prev => {
            const currentStages = prev.statChanges[stat] || 0;
            const newStages = Math.max(-6, Math.min(6, currentStages + stages));
            
            if (newStages !== currentStages) {
                const statNames = { attack: 'Attack', defense: 'Defense', speed: 'Speed', sp_attack: 'Sp. Attack', sp_defense: 'Sp. Defense', accuracy: 'Accuracy', evasion: 'Evasion' };
                const direction = stages > 0 ? 'rose' : 'fell';
                const amount = Math.abs(stages) === 1 ? '' : Math.abs(stages) === 2 ? ' sharply' : ' drastically';
                toast.info(`${targetName}'s ${statNames[stat] || stat}${amount} ${direction}!`, { autoClose: 1500 });
            }
            
            return { ...prev, statChanges: { ...prev.statChanges, [stat]: newStages } };
        });
    };

    const applyStatusEffect = (isPlayer, status) => {
        const setter = isPlayer ? setPlayerEffects : setOpponentEffects;
        const current = isPlayer ? playerEffects : opponentEffects;
        const targetName = isPlayer ? yourPokemon?.naam : oppPokemon?.naam;
        
        if (current.status) {
            toast.warning(`${targetName} is already ${current.status}!`, { autoClose: 1500 });
            return false;
        }
        
        const statusMessages = {
            'burn': `${targetName} was burned!`,
            'poison': `${targetName} was poisoned!`,
            'badly_poisoned': `${targetName} was badly poisoned!`,
            'paralysis': `${targetName} is paralyzed!`,
            'sleep': `${targetName} fell asleep!`,
            'freeze': `${targetName} was frozen solid!`,
            'confusion': `${targetName} became confused!`
        };
        
        toast.warning(statusMessages[status] || `${targetName} was inflicted with ${status}!`, { autoClose: 2000 });
        
        if (status === 'confusion') {
            setter(prev => ({ ...prev, confusion: 3 + Math.floor(Math.random() * 3) }));
        } else {
            setter(prev => ({ ...prev, status, statusTurns: status === 'sleep' ? 1 + Math.floor(Math.random() * 3) : 0 }));
        }
        return true;
    };

    const processStatusDamage = (isPlayer) => {
        const effects = isPlayer ? playerEffects : opponentEffects;
        const pokemon = isPlayer ? yourPokemon : oppPokemon;
        const setPokemon = isPlayer ? setYourPokemon : setOppPokemon;
        
        if (!effects.status || !pokemon) return 0;
        
        let damage = 0;
        const maxHp = pokemon.levenmax || pokemon.leven || 100;
        
        if (effects.status === 'burn' || effects.status === 'poison') {
            damage = Math.max(1, Math.floor(maxHp / 16));
            toast.error(`${pokemon.naam} is hurt by ${effects.status}! (-${damage} HP)`, { autoClose: 1500 });
        } else if (effects.status === 'badly_poisoned') {
            const turns = effects.statusTurns || 1;
            damage = Math.max(1, Math.floor(maxHp * turns / 16));
            const setter = isPlayer ? setPlayerEffects : setOpponentEffects;
            setter(prev => ({ ...prev, statusTurns: prev.statusTurns + 1 }));
            toast.error(`${pokemon.naam} is hurt by poison! (-${damage} HP)`, { autoClose: 1500 });
        }
        
        if (damage > 0) {
            const newHp = Math.max(0, pokemon.leven - damage);
            setPokemon(prev => ({ ...prev, leven: newHp }));
        }
        
        return damage;
    };

    const canAttack = (isPlayer) => {
        const effects = isPlayer ? playerEffects : opponentEffects;
        const pokemon = isPlayer ? yourPokemon : oppPokemon;
        const setter = isPlayer ? setPlayerEffects : setOpponentEffects;
        
        if (effects.status === 'freeze') {
            if (Math.random() < 0.2) {
                setter(prev => ({ ...prev, status: null }));
                toast.success(`${pokemon?.naam} thawed out!`, { autoClose: 1500 });
                return true;
            }
            toast.warning(`${pokemon?.naam} is frozen solid!`, { autoClose: 1500 });
            return false;
        }
        
        if (effects.status === 'sleep') {
            if (effects.statusTurns <= 0) {
                setter(prev => ({ ...prev, status: null, statusTurns: 0 }));
                toast.success(`${pokemon?.naam} woke up!`, { autoClose: 1500 });
                return true;
            }
            setter(prev => ({ ...prev, statusTurns: prev.statusTurns - 1 }));
            toast.warning(`${pokemon?.naam} is fast asleep!`, { autoClose: 1500 });
            return false;
        }
        
        if (effects.status === 'paralysis' && Math.random() < 0.25) {
            toast.warning(`${pokemon?.naam} is paralyzed! It can't move!`, { autoClose: 1500 });
            return false;
        }
        
        if (effects.confusion > 0) {
            setter(prev => ({ ...prev, confusion: prev.confusion - 1 }));
            if (Math.random() < 0.33) {
                const confusionDamage = Math.max(1, Math.floor((pokemon?.levenmax || 100) / 8));
                toast.warning(`${pokemon?.naam} hurt itself in confusion! (-${confusionDamage} HP)`, { autoClose: 1500 });
                const setPokemon = isPlayer ? setYourPokemon : setOppPokemon;
                setPokemon(prev => ({ ...prev, leven: Math.max(0, prev.leven - confusionDamage) }));
                return false;
            }
        }
        
        if (effects.flinch) {
            setter(prev => ({ ...prev, flinch: false }));
            toast.warning(`${pokemon?.naam} flinched!`, { autoClose: 1500 });
            return false;
        }
        
        return true;
    };

    const processAttackEffects = (attackName, damageDealt, isPlayerAttack) => {
        const attackData = attackDataCache[attackName];
        if (!attackData || !attackData.effects) return;
        
        const attackerPokemon = isPlayerAttack ? yourPokemon : oppPokemon;
        const defenderPokemon = isPlayerAttack ? oppPokemon : yourPokemon;
        
        for (const effect of attackData.effects) {
            const chance = attackData.effect_chance || 100;
            if (Math.random() * 100 > chance) continue;
            
            if (effect.type === 'stat_change') {
                const isTargetPlayer = (effect.target === 'user') === isPlayerAttack;
                const statMap = { 'attack': 'attack', 'defense': 'defense', 'special_attack': 'sp_attack', 'special_defense': 'sp_defense', 'speed': 'speed', 'accuracy': 'accuracy', 'evasion': 'evasion' };
                const stat = statMap[effect.stat] || effect.stat;
                applyStatChange(!isTargetPlayer, stat, effect.stages);
            }
            
            if (effect.type === 'status') {
                const isTargetPlayer = (effect.target === 'user') === isPlayerAttack;
                applyStatusEffect(!isTargetPlayer, effect.status);
            }
            
            if (effect.type === 'drain' && damageDealt > 0) {
                const healAmount = Math.max(1, Math.floor(damageDealt * (effect.percent / 100)));
                const setPokemon = isPlayerAttack ? setYourPokemon : setOppPokemon;
                setPokemon(prev => ({ ...prev, leven: Math.min(prev.levenmax || prev.leven + healAmount, prev.leven + healAmount) }));
                toast.success(`${attackerPokemon?.naam} restored ${healAmount} HP!`, { autoClose: 1500 });
            }
            
            if (effect.type === 'recoil' && damageDealt > 0) {
                const recoilDamage = Math.max(1, Math.floor(damageDealt * (effect.percent / 100)));
                const setPokemon = isPlayerAttack ? setYourPokemon : setOppPokemon;
                setPokemon(prev => ({ ...prev, leven: Math.max(0, prev.leven - recoilDamage) }));
                toast.warning(`${attackerPokemon?.naam} was hurt by recoil! (-${recoilDamage} HP)`, { autoClose: 1500 });
            }
            
            if (effect.type === 'flinch') {
                const setter = isPlayerAttack ? setOpponentEffects : setPlayerEffects;
                setter(prev => ({ ...prev, flinch: true }));
            }
        }
    };

    const resetBattleEffects = () => {
        setPlayerEffects({ status: null, statusTurns: 0, statChanges: { attack: 0, defense: 0, speed: 0, sp_attack: 0, sp_defense: 0, accuracy: 0, evasion: 0 }, confusion: 0, flinch: false });
        setOpponentEffects({ status: null, statusTurns: 0, statChanges: { attack: 0, defense: 0, speed: 0, sp_attack: 0, sp_defense: 0, accuracy: 0, evasion: 0 }, confusion: 0, flinch: false });
    }
    const attack = async (item) => {
        if (!isPlayerTurn || attacking || oppAttacking || winLose || !battleActive) {
            console.log("⛔ Player attack canceled - conditions not met");
            return;
        }
        
        if (!yourPokemon || yourPokemon.leven <= 0) {
            console.log("⛔ Player attack canceled - Pokemon has 0 HP");
            toast.warning(t("Cannot attack with a Pokemon that has 0 HP"));
            switchToNextPokemon();
            return;
        }
        
        if (!canAttack(true)) {
            console.log("⛔ Player attack canceled - status effect");
            processStatusDamage(true);
            setIsPlayerTurn(false);
            return;
        }
        
        const attackData = attackDataCache[item.name];
        const isStatusMove = attackData?.category === 'Status' || (attackData?.power === 0 && attackData?.effects?.length > 0);
        
        console.log("🗡️ Player attacking with:", item.name, isStatusMove ? "(Status)" : "");
        setLastActionTime(Date.now());
        
        // חישוב נזק לפי טווח (min-max) אם קיים, אחרת נשתמש בערך הקבוע
        let damage;
        let baseDamage;
        
        // קביעת הנזק הבסיסי - נשתמש ב-minDamage אם קיים, אחרת ב-damage
        if (item.minDamage !== undefined) {
            // אם יש minDamage, זה הנזק הבסיסי
            baseDamage = item.minDamage;
        } else {
            // אם אין minDamage, נשתמש בערך הקבוע
            baseDamage = parseInt(item.damage || 50);
        }
        
        // 🎯 חישוב יתרון סוג התקפה
        const attackType = item.type || 'Normal';
        const defenderType1 = oppPokemon?.type1 || 'Normal';
        const defenderType2 = oppPokemon?.type2 || null;
        const typeMultiplier = getTypeEffectiveness(attackType, defenderType1, defenderType2);
        
        console.log("🎯 Type Effectiveness:", attackType, "vs", defenderType1, defenderType2 || '', "=", typeMultiplier + "x");
        
        // חישוב נזק מבוסס על הנוסחה: Damage = ((Attack / Defence) * BasePower * Modifier)
        let calculatedDamage;
        if (isTrainerBattle) {
            // בקרב מאמן: חישוב לפי הנוסחה המפורטת
            // 1. חישוב סטטיסטיקות לפי הנוסחה: attack_base * (1 + level / 50)
            const playerLevel = yourPokemon?.level || 50;
            const playerAttackBase = yourPokemon?.attack_base || 50;
            const playerSpAttackBase = yourPokemon?.['spc.attack_base'] || yourPokemon?.spc_attack_base || 50;
            const enemyDefenceBase = oppPokemon?.defence_base || 50;
            const enemySpDefenceBase = oppPokemon?.['spc.defence_base'] || oppPokemon?.spc_defence_base || 50;
            const enemyLevel = oppPokemon?.level || 50;
            
            // חישוב Attack ו-Defence לפי הנוסחה
            const playerAttack = playerAttackBase * (1 + playerLevel / 50);
            const playerSpAttack = playerSpAttackBase * (1 + playerLevel / 50);
            const enemyDefence = enemyDefenceBase * (1 + enemyLevel / 50);
            const enemySpDefence = enemySpDefenceBase * (1 + enemyLevel / 50);
            
            // החלטה אם זו התקפה פיזית או מיוחדת לפי סוג המתקפה
            const isPhysicalAttack = !item.type || ['Normal', 'Fighting', 'Flying', 'Poison', 'Ground', 'Rock', 'Bug', 'Ghost', 'Steel'].includes(item.type);
            const attackStat = isPhysicalAttack ? playerAttack : playerSpAttack;
            const defenceStat = isPhysicalAttack ? enemyDefence : enemySpDefence;
            
            // BasePower = damage של המתקפה
            const basePower = baseDamage;
            
            // Modifier = TypeEffect * Crit * Random
            // TypeEffect כבר מחושב ב-typeMultiplier
            const critChance = 0.0625; // 6.25% chance for critical hit
            const isCrit = Math.random() < critChance;
            const critMultiplier = isCrit ? 1.5 : 1.0;
            const randomMultiplier = 0.85 + Math.random() * 0.25; // 0.85 to 1.1
            
            const modifier = typeMultiplier * critMultiplier * randomMultiplier;
            
            // Damage = ((Attack / Defence) * BasePower * Modifier)
            calculatedDamage = Math.max(1, Math.floor((attackStat / Math.max(1, defenceStat)) * basePower * modifier));
            
            console.log("⚡ Trainer Battle - Formula calculation:", 
                "Attack:", attackStat.toFixed(2), "/ Defence:", defenceStat.toFixed(2), 
                "* BasePower:", basePower, "* Modifier:", modifier.toFixed(3),
                "=", calculatedDamage, isCrit ? "(CRIT!)" : "");
        } else if (isMapBattle) {
            // בקרב מפה רגיל, נזק כפול 3 עם טווח
            const minDamage = baseDamage;
            const maxDamage = baseDamage * 3;
            calculatedDamage = Math.floor(minDamage + Math.random() * (maxDamage - minDamage + 1));
            console.log("⚡ Map Battle - Attack damage range:", minDamage, "-", maxDamage, "Base:", baseDamage, "Final damage:", calculatedDamage);
        } else {
            // בקרב רגיל, נשתמש בטווח הקיים או בערך הקבוע
            if (item.minDamage !== undefined && item.maxDamage !== undefined) {
                calculatedDamage = Math.floor(item.minDamage + Math.random() * (item.maxDamage - item.minDamage + 1));
            } else {
                calculatedDamage = baseDamage;
            }
            console.log("⚡ Regular Battle - Attack damage range:", item.minDamage, "-", item.maxDamage, "Final damage:", calculatedDamage);
        }
        
        damage = calculatedDamage;
        
        // בקרב מאמן, typeMultiplier כבר כלול ב-modifier, אז לא צריך להכפיל שוב
        // בקרבות אחרים, נשתמש ב-typeMultiplier כרגיל
        if (!isTrainerBattle) {
            // 🎯 יישום מכפיל יתרון סוג
            const originalDamage = damage;
            let damageAfterType = Math.floor(damage * typeMultiplier);
            
            // אם הנזק הוא 0 (לא משפיע), עדיין נגרום לנזק מינימלי
            if (damageAfterType === 0 && typeMultiplier === 0) {
                // נזק מינימלי = 5% מהנזק הבסיסי, לפחות 1
                damageAfterType = Math.max(1, Math.floor(originalDamage * 0.05));
                console.log("⚡ Attack doesn't affect, but applying minimum damage:", damageAfterType);
            }
            
            damage = damageAfterType;
        }
        
        // 🎮 יישום מכפיל עוצמת שחקן מהגדרות
        const playerStrengthMultiplier = parseInt(battleSettings?.player_strength_percent || '100') / 100;
        damage = Math.floor(damage * playerStrengthMultiplier);
        
        // וידוא שהנזק הוא לפחות 1
        damage = Math.max(1, damage);
        
        console.log("🎮 Player Strength Multiplier:", playerStrengthMultiplier, "Damage after:", damage);
        
        // הצגת הודעת יתרון סוג
        const effectivenessMessage = getTypeEffectivenessMessage(typeMultiplier);
        if (effectivenessMessage) {
            console.log("💥 Type Effectiveness Message:", effectivenessMessage.text);
            toast.info(effectivenessMessage.text, {
                style: { 
                    backgroundColor: effectivenessMessage.color === '#00ff00' ? '#1a472a' : 
                                    effectivenessMessage.color === '#00ffff' ? '#0d3d4d' :
                                    effectivenessMessage.color === '#ffaa00' ? '#4d3d0d' : '#4d0d0d',
                    color: effectivenessMessage.color,
                    fontWeight: 'bold'
                },
                autoClose: 1500
            });
        }
        
        // הצגת סיכום נזק
        if (!isTrainerBattle) {
            console.log("⚡ Damage after type effectiveness:", damage, "(type multiplier:", typeMultiplier + "x)");
        } else {
            console.log("⚡ Final damage:", damage);
        }
        
        // עדכון currentAttack עם הנזק המחושב כדי להציג אותו על המסך
        setAttacking(true);
        setCurrentAttack({ ...item, damage: damage });
        
        // אפקט רעידת מסך להתקפות חזקות (נזק מעל 20)
        if (damage >= 20) {
            setScreenShake(true);
            setTimeout(() => setScreenShake(false), 400);
        }
        
        // Start attack animation - your pokemon attacks (moves forward), opponent gets hit (moves back)
        // We'll use the attacking state to determine which animation to show
        // Animation will be handled by CSS classes based on attacking/oppAttacking states
        
        console.log("⚡ Final damage:", damage, "Enemy HP before:", oppPokemon.leven);
        
        let new_hp = oppPokemon.leven;
        
        if (isStatusMove && damage === 0) {
            console.log("📊 Status move - applying effects only");
            processAttackEffects(item.name, 0, true);
        } else {
            new_hp = Math.max(0, oppPokemon.leven - damage);
            console.log("💔 Enemy HP after:", new_hp);
            setOppPokemon({ ...oppPokemon, leven: new_hp });
            
            setTimeout(() => processAttackEffects(item.name, damage, true), 500);
        }
        
        // Update trainer pokemon HP in trainer battle
        if (isTrainerBattle && trainerPokemonList.length > 0) {
            setTrainerPokemonList(prev => prev.map(p => {
                if (p.wild_id === oppPokemon?.wild_id && p.slot_position === currentTrainerPokemonIndex) {
                    return { ...p, current_hp: Math.max(0, new_hp) };
                }
                return p;
            }));
        }

        // אם זה קרב מפה, לא צריך לשלוח לשרת
        if (!isMapBattle) {
            try {
                await dispatch(doAttck(item)).unwrap();
                console.log("✅ Attack sent to server");
            } catch (error) {
                console.error("❌ Error sending attack to server:", error);
                // ממשיכים בקרב גם במקרה של שגיאה
            }
        }
        
        // עדכון מצב הקרב לאחר ההתקפה
        updateBattleState({ forceUpdate: true });
        
        // סיום אנימציית התקפה
        setTimeout(() => {
            if (!componentMounted.current || !battleActive) {
                console.log("⚠️ Component unmounted during attack animation");
                return;
            }
            
            console.log("Attack animation completed");
            setAttacking(false);
            setCurrentAttack({});
            
            // בדיקה אם הקרב הסתיים
            if (new_hp <= 0) {
                // Check if this is a trainer battle - if so, check if trainer has more Pokemon
                if (isTrainerBattle && trainerPokemonList.length > 0) {
                    // Mark current trainer pokemon as fainted
                    setTrainerPokemonList(prev => prev.map(p => {
                        // Check if this is the current opponent pokemon (match by wild_id and slot)
                        if (p.wild_id === oppPokemon?.wild_id && p.slot_position === currentTrainerPokemonIndex) {
                            return { ...p, is_fainted: true, current_hp: 0 };
                        }
                        return p;
                    }));
                    
                    // Check if there are more trainer Pokemon available
                    const aliveTrainerPokemon = trainerPokemonList.filter(p => 
                        !p.is_fainted && p.slot_position !== currentTrainerPokemonIndex
                    );
                    
                    if (aliveTrainerPokemon.length > 0) {
                        // Trainer has more Pokemon - switch to next one
                        const nextTrainerPoke = aliveTrainerPokemon[0];
                        console.log("👤 Trainer Pokemon fainted, switching to next:", nextTrainerPoke.name);
                        
                        // Update current trainer pokemon index
                        const nextIndex = nextTrainerPoke.slot_position;
                        setCurrentTrainerPokemonIndex(nextIndex);
                        
                        // Add fainting animation
                        setPokemonSwitching('fainting');
                        
                        // Switch to next trainer Pokemon with transition animation
                        setTimeout(() => {
                            const nextOppPokemon = {
                                id: `trainer-${nextTrainerPoke.id}-${Date.now()}`,
                                naam: nextTrainerPoke.name,
                                level: nextTrainerPoke.level,
                                wild_id: nextTrainerPoke.wild_id,
                                leven: nextTrainerPoke.current_hp,
                                levenmax: nextTrainerPoke.max_hp,
                                origina_level: nextTrainerPoke.max_hp,
                                type1: nextTrainerPoke.type1,
                                type2: nextTrainerPoke.type2 || '',
                                attack: nextTrainerPoke.attack,
                                defence: nextTrainerPoke.defence,
                                speed: nextTrainerPoke.speed,
                                'spc.attack': nextTrainerPoke.spc_attack,
                                'spc.defence': nextTrainerPoke.spc_defence,
                                ability: nextTrainerPoke.ability || '',
                                base_exp: nextTrainerPoke.base_exp || 100,
                                attack_base: nextTrainerPoke.attack_base || 50,
                                defence_base: nextTrainerPoke.defence_base || 50,
                                speed_base: nextTrainerPoke.speed_base || 50,
                                'spc.attack_base': nextTrainerPoke.spc_attack_base || 50,
                                'spc.defence_base': nextTrainerPoke.spc_defence_base || 50,
                                hp_base: nextTrainerPoke.hp_base || 50,
                                karakter: 'Hardy'
                            };
                            setOppPokemon(null);
                            setPokemonSwitching(null);
                            
                            setTimeout(() => {
                                setOppPokemon(nextOppPokemon);
                                setPokemonSwitching('appearing');
                                toast.info(t('{{name}} sent out {{pokemon}}!', { 
                                    name: trainerName, 
                                    pokemon: nextTrainerPoke.name 
                                }));
                                setIsPlayerTurn(true);
                                
                                setTimeout(() => {
                                    setPokemonSwitching(null);
                                }, 1000);
                                
                                updateBattleState({ forceUpdate: true });
                            }, 800);
                        }, 1000);
                        return; // Exit early - don't show win yet
                    } else {
                        // All trainer Pokemon are defeated - player wins
                        console.log("🎉 Player won the trainer battle!");
                        setWinLose('win');
                        updateBattleState({ forceUpdate: true, winLose: 'win' });
                        
                        if (isTrainerBattle && trainerBattleId && yourPokemon?.id) {
                            handleBattleFinish('win');
                        }
                        
                        setTimeout(() => {
                            if (componentMounted.current) {
                                console.log("🗺️ Trainer battle won - navigating to map");
                                localStorage.removeItem('activeBattle');
                                localStorage.removeItem('battleNavigationLocked');
                                localStorage.removeItem('battleInitTime');
                                localStorage.removeItem('battleInstanceTime');
                                navigate('/map');
                            }
                        }, 2000);
                        return; // Exit early
                    }
                } else {
                    // Regular battle - player wins
                    console.log("🎉 Player won the battle!");
                    setWinLose('win');
                    // הקרב נשאר פעיל כדי להציג את מסך הניצחון
                    
                    // שמירת מצב מעודכן עם תוצאת הקרב
                    updateBattleState({ forceUpdate: true, winLose: 'win' });
                    
                // Send win result to server for rewards
                if (isMapBattle && yourPokemon?.id) {
                    handleBattleFinish('win');
                }
                
                // Also handle trainer battle wins
                if (isTrainerBattle && trainerBattleId && yourPokemon?.id) {
                    handleBattleFinish('win');
                }
                    
                    // ניווט ל-map אחרי 2 שניות במקרה של ניצחון בקרב מפה, אחרת ל-home
                    setTimeout(() => {
                        if (componentMounted.current && winLose === 'win') {
                            console.log(isMapBattle ? "🗺️ Battle won - navigating to map" : "🏠 Battle won - navigating to home");
                            localStorage.removeItem('activeBattle');
                            localStorage.removeItem('battleNavigationLocked');
                            localStorage.removeItem('battleInitTime');
                            localStorage.removeItem('battleInstanceTime');
                            if (isMapBattle) {
                                navigate('/map');
                            } else {
                                logToFile("Navigating to /home (non-map battle)", {
                                    isMapBattle,
                                    isTrainerBattle,
                                    winLose
                                });
                                navigate('/home');
                            }
                        }
                    }, 2000);
                }
            } else if (isMapBattle) {
                // העברת התור לאויב - חשוב: לשמור את המצב לפני העברת התור
                console.log("🔄 Switching turn to enemy");
                setIsPlayerTurn(false);
                setLastActionTime(Date.now());
                
                // שמירת מצב מעודכן עם העברת התור - חשוב מאוד לשמור את isPlayerTurn: false
                setTimeout(() => {
                    updateBattleState({ forceUpdate: true, isPlayerTurn: false });
                }, 100);
            }
        }, 1000);
    };
    
    // פונקציה למעבר אוטומטי לפוקימון הבא כאשר הפוקימון הנוכחי מגיע ל-0 חיים
    const switchToNextPokemon = () => {
        console.log("🔄 Attempting to switch to next Pokemon");
        
        // עדכון ה-HP של הפוקימון הנוכחי ב-battlePokemons ומציאת הפוקימון הבא
        setBattlePokemons(prev => {
            // עדכון ה-HP של הפוקימון הנוכחי ל-0
            const updated = prev.map(p => 
                p.id === yourPokemon?.id ? { ...p, leven: 0 } : p
            );
            
            // מציאת הפוקימון הבא עם HP > 0
            const nextPokemon = updated.find(p => 
                p.id !== yourPokemon?.id && p.leven > 0
            );
            
            if (nextPokemon) {
                console.log("✅ Switching to next Pokemon:", nextPokemon.naam);
                setTimeout(() => {
                    if (componentMounted.current) {
                        setYourPokemon(nextPokemon);
                        updateAttacksForPokemon(nextPokemon);
                        setPlayerEffects({ status: null, statusTurns: 0, statChanges: { attack: 0, defense: 0, speed: 0, sp_attack: 0, sp_defense: 0, accuracy: 0, evasion: 0 }, confusion: 0, flinch: false });
                        setIsPlayerTurn(true);
                        setLastActionTime(Date.now());
                        toast.info(t('{{name}} entered the battle!', { name: nextPokemon.naam }));
                    }
                }, 100);
            } else {
                console.log("❌ No more Pokemon available - all fainted");
                // כל הפוקימונים נהרגו
                setTimeout(() => {
                    if (componentMounted.current) {
                        setWinLose('lose');
                        if (isMapBattle) {
                            handleBattleFinish('lose');
                            // ניווט ל-hospital אחרי 2 שניות
                            setTimeout(() => {
                                if (componentMounted.current) {
                                    console.log("🏥 All Pokemon fainted - navigating to hospital");
                                    localStorage.removeItem('activeBattle');
                                    localStorage.removeItem('battleNavigationLocked');
                                    localStorage.removeItem('battleInitTime');
                                    localStorage.removeItem('battleInstanceTime');
                                    navigate('/hospital');
                                }
                            }, 2000);
                        }
                    }
                }, 100);
            }
            
            return updated;
        });
        
        // בדיקה אם יש פוקימון נוסף (לפני העדכון)
        const hasNextPokemon = battlePokemons.some(p => 
            p.id !== yourPokemon?.id && p.leven > 0
        );
        
        return hasNextPokemon;
    };
    
    // פונקציה להתקפת האויב - שיפורים למניעת באגים ויציאות לא רצויות
    const opp_attack = (data) => {
        console.log("⚔️ Enemy attack function called with data:", data);
        
        // בדיקות תקינות נרחבות לפני התקפה
        if (!componentMounted.current) {
            console.log("⛔ Enemy attack canceled - component not mounted");
            return;
        }
        
        if (!battleInitialized.current) {
            console.log("⛔ Enemy attack canceled - battle not initialized");
            return;
        }
        
        if (!battleActive) {
            console.log("⛔ Enemy attack canceled - battle not active");
            return;
        }
        
        if (winLose) {
            console.log("⛔ Enemy attack canceled - battle already ended with:", winLose);
            return;
        }
        
        if (attacking || oppAttacking) {
            console.log("⛔ Enemy attack canceled - attack already in progress");
            return;
        }
        
        if (isPlayerTurn) {
            console.log("⛔ Enemy attack canceled - it's player's turn");
            return;
        }
        
        // וידוא שיש מידע תקין
        if (!yourPokemon || !oppPokemon || !yourPokemon.leven || !oppPokemon.leven) {
            console.log("⛔ Enemy attack canceled - invalid Pokemon data");
            return;
        }
        
        if (yourPokemon.leven <= 0) {
            console.log("⚠️ Current Pokemon has 0 HP - switching to next Pokemon");
            switchToNextPokemon();
            return;
        }
        
        if (!canAttack(false)) {
            console.log("⛔ Enemy attack canceled - status effect");
            processStatusDamage(false);
            setIsPlayerTurn(true);
            return;
        }
        
        setOppAttacking(true);
        setLastActionTime(Date.now());
        console.log("🔥 Enemy executing attack:", data.name || "Unknown attack");
        
        // Start attack animation - opponent pokemon attacks (moves forward), your pokemon gets hit (moves back)
        // Animation will be handled by CSS classes based on attacking/oppAttacking states
        
        // המרת הנזק למספר אם הוא מחרוזת
        let damage = parseInt(data.damage);
        
        // חישוב נזק מבוסס על הנוסחה: Damage = ((Attack / Defence) * BasePower * Modifier)
        let calculatedDamage;
        if (isTrainerBattle && oppPokemon && oppPokemon.attack) {
            // בקרב מאמן: חישוב לפי הנוסחה המפורטת
            // 1. חישוב סטטיסטיקות לפי הנוסחה: attack_base * (1 + level / 50)
            const enemyLevel = oppPokemon.level || 50;
            const enemyAttackBase = oppPokemon.attack_base || 50;
            const enemySpAttackBase = oppPokemon?.['spc.attack_base'] || oppPokemon?.spc_attack_base || 50;
            const playerDefenceBase = yourPokemon?.defence_base || 50;
            const playerSpDefenceBase = yourPokemon?.['spc.defence_base'] || yourPokemon?.spc_defence_base || 50;
            const playerLevel = yourPokemon?.level || 50;
            
            // חישוב Attack ו-Defence לפי הנוסחה
            const enemyAttack = enemyAttackBase * (1 + enemyLevel / 50);
            const enemySpAttack = enemySpAttackBase * (1 + enemyLevel / 50);
            const playerDefence = playerDefenceBase * (1 + playerLevel / 50);
            const playerSpDefence = playerSpDefenceBase * (1 + playerLevel / 50);
            
            // החלטה אם זו התקפה פיזית או מיוחדת לפי סוג המתקפה
            const attackType = data.type || oppPokemon?.type1 || 'Normal';
            const isPhysicalAttack = ['Normal', 'Fighting', 'Flying', 'Poison', 'Ground', 'Rock', 'Bug', 'Ghost', 'Steel'].includes(attackType);
            const attackStat = isPhysicalAttack ? enemyAttack : enemySpAttack;
            const defenceStat = isPhysicalAttack ? playerDefence : playerSpDefence;
            
            // BasePower - נשתמש ב-damage מהנתונים או ערך ברירת מחדל
            const basePower = damage || 50;
            
            // Modifier = TypeEffect * Crit * Random
            // חישוב TypeEffect
            const defenderType1 = yourPokemon?.type1 || 'Normal';
            const defenderType2 = yourPokemon?.type2 || null;
            const typeMultiplier = getTypeEffectiveness(attackType, defenderType1, defenderType2);
            
            const critChance = 0.0625; // 6.25% chance for critical hit
            const isCrit = Math.random() < critChance;
            const critMultiplier = isCrit ? 1.5 : 1.0;
            const randomMultiplier = 0.85 + Math.random() * 0.25; // 0.85 to 1.1
            
            const modifier = typeMultiplier * critMultiplier * randomMultiplier;
            
            console.log("🎯 Enemy Type Effectiveness:", attackType, "vs", defenderType1, defenderType2 || '', "=", typeMultiplier + "x");
            
            // Damage = ((Attack / Defence) * BasePower * Modifier)
            calculatedDamage = Math.max(1, Math.floor((attackStat / Math.max(1, defenceStat)) * basePower * modifier));
            
            console.log("⚡ Trainer Battle - Enemy formula calculation:", 
                "Attack:", attackStat.toFixed(2), "/ Defence:", defenceStat.toFixed(2), 
                "* BasePower:", basePower, "* Modifier:", modifier.toFixed(3),
                "=", calculatedDamage, isCrit ? "(CRIT!)" : "");
        } else {
            // נזק מותאם לרמת המפלצת - חזק יותר כדי לאתגר את השחקן
            const levelRatio = oppPokemon.level / (yourPokemon.level || 1);
            const levelFactor = Math.min(1.5, Math.max(0.8, levelRatio));
            calculatedDamage = Math.floor(damage * 0.7 * levelFactor);
        }
        
        damage = calculatedDamage;
        
        // בקרב מאמן, typeMultiplier כבר כלול ב-modifier, אז לא צריך להכפיל שוב
        // בקרבות אחרים, נשתמש ב-typeMultiplier כרגיל
        if (!isTrainerBattle) {
            // 🎯 חישוב יתרון סוג התקפה של האויב
            const attackType = data.type || oppPokemon?.type1 || 'Normal'; // האויב משתמש בסוג שלו
            const defenderType1 = yourPokemon?.type1 || 'Normal';
            const defenderType2 = yourPokemon?.type2 || null;
            const typeMultiplier = getTypeEffectiveness(attackType, defenderType1, defenderType2);
            
            console.log("🎯 Enemy Type Effectiveness:", attackType, "vs", defenderType1, defenderType2 || '', "=", typeMultiplier + "x");
            
            // יישום מכפיל יתרון סוג
            let damageAfterType = Math.floor(damage * typeMultiplier);
            
            // אם הנזק הוא 0 (לא משפיע), עדיין נגרום לנזק מינימלי
            if (damageAfterType === 0 && typeMultiplier === 0) {
                // נזק מינימלי = 5% מהנזק הבסיסי, לפחות 1
                const originalEnemyDamage = damage;
                damageAfterType = Math.max(1, Math.floor(originalEnemyDamage * 0.05));
                console.log("⚡ Enemy attack doesn't affect, but applying minimum damage:", damageAfterType);
            }
            
            damage = damageAfterType;
        }
        
        // 🎮 יישום מכפיל עוצמת אויב מהגדרות
        const enemyStrengthMultiplier = parseInt(battleSettings?.enemy_strength_percent || '100') / 100;
        damage = Math.floor(damage * enemyStrengthMultiplier);
        
        // וידוא שהנזק הוא לפחות 1
        damage = Math.max(1, damage);
        
        console.log("🎮 Enemy Strength Multiplier:", enemyStrengthMultiplier, "Damage after:", damage);
        
        // הצגת הודעת יתרון סוג של האויב
        // בקרב מאמן, typeMultiplier כבר מחושב בחישוב הנזק
        // בקרבות אחרים, נחשב אותו כאן
        let finalTypeMultiplier = 1.0;
        if (isTrainerBattle && oppPokemon && oppPokemon.attack) {
            // typeMultiplier כבר מחושב בחישוב הנזק למעלה
            const attackType = data.type || oppPokemon?.type1 || 'Normal';
            const defenderType1 = yourPokemon?.type1 || 'Normal';
            const defenderType2 = yourPokemon?.type2 || null;
            finalTypeMultiplier = getTypeEffectiveness(attackType, defenderType1, defenderType2);
        } else if (!isTrainerBattle) {
            // בקרבות אחרים, typeMultiplier כבר מחושב למעלה
            const attackType = data.type || oppPokemon?.type1 || 'Normal';
            const defenderType1 = yourPokemon?.type1 || 'Normal';
            const defenderType2 = yourPokemon?.type2 || null;
            finalTypeMultiplier = getTypeEffectiveness(attackType, defenderType1, defenderType2);
        }
        
        const effectivenessMessage = getTypeEffectivenessMessage(finalTypeMultiplier);
        if (effectivenessMessage) {
            console.log("💥 Enemy Type Effectiveness Message:", effectivenessMessage.text);
            // הודעה אדומה/צהובה לשחקן שהתקפת האויב הייתה אפקטיבית
            toast.info(`Enemy: ${effectivenessMessage.text}`, {
                style: { 
                    backgroundColor: effectivenessMessage.color === '#00ff00' ? '#4d0d0d' : // אם האויב חזק - אדום
                                    effectivenessMessage.color === '#00ffff' ? '#4d0d0d' :
                                    effectivenessMessage.color === '#ffaa00' ? '#0d4d0d' : '#0d4d0d', // אם האויב חלש - ירוק
                    color: effectivenessMessage.color === '#00ff00' || effectivenessMessage.color === '#00ffff' ? '#ff6666' : '#66ff66',
                    fontWeight: 'bold'
                },
                autoClose: 1500
            });
        }
        
        // מגבלת מקסימום לנזק - גבוהה יותר
        const maxDamageByHP = Math.floor(yourPokemon.levenmax * 0.4); // הוגדל מ-25% ל-40%
        damage = Math.min(damage, 80, maxDamageByHP); // הוגדל מ-40 ל-80
        
        // אם הנזק הוא 0 (לא משפיע), עדיין נגרום לנזק מינימלי
        if (damage === 0 && finalTypeMultiplier === 0) {
            // נזק מינימלי = 5% מהנזק הבסיסי, לפחות 1
            const originalEnemyDamage = damage;
            damage = Math.max(1, Math.floor((originalEnemyDamage || 10) * 0.05));
            console.log("⚡ Enemy attack doesn't affect, but applying minimum damage:", damage);
        } else if (finalTypeMultiplier > 0) {
            damage = Math.max(8, damage); // הוגדל מ-3 ל-8
        } else {
            // גם אם typeMultiplier הוא בין 0 ל-1 (לא יעיל), וודא נזק מינימלי
            damage = Math.max(1, damage);
        }
        
        console.log("⚡ Final damage:", damage, "Player HP before:", yourPokemon.leven);
        setCurrentAttack({ ...data, damage });
        
        // אפקט רעידת מסך להתקפות חזקות (נזק מעל 15)
        if (damage >= 15) {
            setScreenShake(true);
            setTimeout(() => setScreenShake(false), 400);
        }
        
        let new_hp = Math.max(0, yourPokemon.leven - damage);
        console.log("💔 Player HP after:", new_hp);
        
        setTimeout(() => {
            const attackName = data.name || 'Unknown';
            if (attackDataCache[attackName]) {
                processAttackEffects(attackName, damage, false);
            }
        }, 500);
        
        // עדכון נקודות החיים של השחקן
        const updatedPokemon = { ...yourPokemon, leven: new_hp };
        setYourPokemon(updatedPokemon);
        
        // עדכון גם ברשימת הפוקימונים בקרב - חשוב לשמור את ה-HP המעודכן
        setBattlePokemons(prev => prev.map(p => 
            p.id === yourPokemon.id ? { ...p, leven: new_hp } : p
        ));
        
        // שמירת מצב הקרב עם ה-HP המעודכן
        setTimeout(() => {
            updateBattleState({ forceUpdate: true });
        }, 100);
        
        // שמירת המצב לאחר ההתקפה
        setTimeout(() => {
            if (!componentMounted.current) {
                console.log("⚠️ Component unmounted during attack animation");
                return;
            }
            
            updateBattleState({ forceUpdate: true });
            
            // סיום אנימציית התקפה
            setTimeout(() => {
                if (!componentMounted.current) {
                    console.log("⚠️ Component unmounted during post-attack");
                    return;
                }
                
                console.log("Attack animation completed");
                setOppAttacking(false);
                
                // בדיקה אם הקרב הסתיים
                if (new_hp <= 0) {
                    console.log("❌ Current Pokemon fainted!");
                    
                    // ניסיון לעבור לפוקימון הבא
                    const hasNextPokemon = switchToNextPokemon();
                    
                    if (!hasNextPokemon) {
                        // אין פוקימון נוסף - הקרב הסתיים בהפסד
                        console.log("❌ All Pokemon defeated!");
                        setWinLose('lose');
                        // הקרב נשאר פעיל כדי להציג את מסך ההפסד
                        
                        // Send lose result to server
                        if (isMapBattle) {
                            handleBattleFinish('lose');
                        }
                    }
                    // אם יש פוקימון נוסף, switchToNextPokemon כבר מעדכן את המצב
                } else {
                    // החזרת התור לשחקן
                    console.log("🔄 Returning turn to player");
                    setIsPlayerTurn(true);
                    setLastActionTime(Date.now());
                    
                    // שמירת מצב מעודכן עם העברת התור לשחקן - חשוב מאוד!
                    setTimeout(() => {
                        updateBattleState({ forceUpdate: true, isPlayerTurn: true });
                    }, 100);
                }
            }, 1000);
        }, 500);
    };
    const attckLog=()=>{
        try {
            // רק אם נמצא ב-getDualData בפעם הראשונה, נבצע בדיקה
            if (!battleActive || !battleInitialized.current) return;
            
            // אם זה קרב מפה, לא צריך לשאול את השרת
            if (isMapBattle) return;
            
            // אם כבר יש תוצאה לקרב, אין טעם לשאול יותר
            if (winLose) return;
            
            let payload = {
                duel_id: duel_data?.duel_data?.id
            }
            // console.log(payload)
            dispatch(getAttckLogs(payload)).unwrap().then((res)=>{
                // בגלל שהיו חוסר התאמות בנתונים לפעמים, נבטיח שלא נצא מהקרב במקרה של שגיאה
                if (!res || res?.error) {
                    console.error("שגיאה בתגובת השרת:", res);
                    return;
                }
                
                res?.data?.map((item)=>{
                    // לא נאפשר בדיקות או עדכונים אם הקרב כבר הסתיים
                    if (winLose) return;
                    
                    // בדיקה שיש די נתונים להתקפה
                    if (!item?.damage || !yourPokemon?.leven) return;
                    
                    // השתמש בהעתק של המידע הנוכחי ולא בהפניה ישירה
                    const currentYourPokemon = {...yourPokemon};
                    const damage = parseInt(item?.damage);
                    const new_hp = Math.max(0, currentYourPokemon.leven - damage);
                    
                    setYourPokemon({...currentYourPokemon, leven: new_hp})
                    setCurrentAttack(item)
                    
                    if(new_hp <= 0){
                        // חשוב: לא נשנה את מצב הקרב לא פעיל כי אנחנו רוצים לאפשר למשתמש לראות את תוצאת הקרב
                        setWinLose('lose')
                    }
                })  
            }).catch(err => {
                console.error("שגיאה בקריאה לשרת:", err);
                // במקרה של שגיאה, אל תעשה כלום - פשוט תמשיך את הקרב במצבו הנוכחי
            })
        } catch (error) {
            console.error("שגיאה בפונקציית attckLog:", error);
            // גם כאן, במקרה של שגיאה, פשוט תמשיך בלי לעשות שום דבר שיכול להפריע למשחק
        }
    }

    // טעינת הגדרות קרב מהשרת
    useEffect(() => {
        dispatch(getBattleSettings());
    }, [dispatch]);

    useEffect(() => {
        // סימון שהקומפוננטה נטענה
        componentMounted.current = true;
        console.log("🔄 Battle component mounted. battleActive:", battleActive, "isFirstLoad:", isFirstLoad.current, "isMapBattle:", isMapBattle);
        logToFile("Battle component mounted", {
            battleActive,
            isFirstLoad: isFirstLoad.current,
            isMapBattle,
            isTrainerBattle,
            trainerBattleId,
            url: window.location.href,
            searchParams: Object.fromEntries(searchParams.entries())
        });
        
        // הפונקציה להתחלת קרב
        const handleInitialBattle = async () => {
            try {
                console.log("🚀 Initializing battle... Map battle:", isMapBattle);
                await logToFile("Starting battle initialization", {
                    isMapBattle,
                    isTrainerBattle,
                    trainerBattleId,
                    url: window.location.href
                });
                
                // איתור זמן אתחול אחרון של הקרב
                const lastInitTime = parseInt(localStorage.getItem('battleInitTime') || '0');
                const currentTime = Date.now();
                
                // שמירת זמן אתחול הקרב - משמש למניעת יציאה מהירה מהקרב
                localStorage.setItem('battleInitTime', currentTime.toString());
                console.log("⏱️ Battle init time saved:", currentTime);
                
                // אם עברו פחות מ-10 שניות מאז האתחול האחרון, זה מרמז על רימאונט
                // ולא על אתחול אמיתי של קרב חדש
                // אבל רק אם זה אותו סוג קרב (map battle או duel)
                const savedBattleState = localStorage.getItem('activeBattle');
                if (currentTime - lastInitTime < 10000 && savedBattleState) {
                    try {
                        const battleState = JSON.parse(savedBattleState);
                        
                        // בדוק אם זה אותו סוג קרב (map battle או duel)
                        const isSameBattleType = (battleState.isMapBattle && isMapBattle) || 
                                                 (!battleState.isMapBattle && !isMapBattle);
                        
                        if (!isSameBattleType) {
                            console.log("⚠️ Different battle type detected, starting new battle");
                            // נקה את הקרב הישן
                            localStorage.removeItem('activeBattle');
                            localStorage.removeItem('battleNavigationLocked');
                            localStorage.removeItem('battleInitTime');
                            localStorage.removeItem('battleInstanceTime');
                            // המשך לאתחול קרב חדש
                        } else if (battleState.winLose) {
                            // קרב שכבר הסתיים - נקה ונצא
                            console.log("🏁 Battle already ended, cleaning up");
                            localStorage.removeItem('activeBattle');
                            localStorage.removeItem('battleNavigationLocked');
                            localStorage.removeItem('battleInitTime');
                            localStorage.removeItem('battleInstanceTime');
                            setIsLoading(false);
                            // Navigate to map if it was a map battle
                            if (battleState.isMapBattle) {
                                console.log("🗺️ Navigating to map after completed battle");
                                navigate('/map');
                            } else {
                                console.log("🏠 Navigating to home after completed duel");
                                logToFile("Navigating to /home after completed duel", {
                                    isMapBattle,
                                    isTrainerBattle
                                });
                                navigate('/home');
                            }
                            return;
                        } else {
                            // זה אותו קרב - טען אותו
                            console.log("⚠️ Detected rapid re-initialization. Loading from saved state.");
                            
                            // אתחול הקרב עם הנתונים המשוחזרים - הגנה 1: טעינת מצב הקרב אחרי רענון
                            setYourPokemon(battleState.yourPokemon);
                            setOppPokemon(battleState.oppPokemon);
                            // עדכון ההתקפות לפי הפוקימון המשוחזר
                            if (battleState.yourPokemon) {
                                updateAttacksForPokemon(battleState.yourPokemon);
                            } else {
                                setAttackList(battleState.attackList || attackList);
                            }
                            setIsPlayerTurn(battleState.isPlayerTurn);
                            // Restore battlePokemons if available - filter to only team Pokemon
                            if (battleState.battlePokemons && Array.isArray(battleState.battlePokemons)) {
                                const teamPokemons = battleState.battlePokemons.filter(p => p.opzak === 'ja');
                                setBattlePokemons(teamPokemons);
                                console.log("🔍 Restored battlePokemons - filtered to team only:", teamPokemons.length, "out of", battleState.battlePokemons.length);
                            }
                            setBattleActive(true);
                            setLastActionTime(Date.now());
                            // שחזור טיימר הקרב אם קיים
                            const savedStartTime = battleState.battleStartTime;
                            if (savedStartTime) {
                                const elapsed = Math.floor((Date.now() - savedStartTime) / 1000);
                                const remaining = Math.max(0, 180 - elapsed);
                                setBattleStartTime(savedStartTime);
                                setBattleTimer(remaining);
                                console.log("⏱️ Battle timer restored:", remaining, "seconds remaining");
                            } else {
                                // אם אין זמן שמור, התחל מחדש
                                setBattleStartTime(Date.now());
                                setBattleTimer(180);
                            }
                            
                            // סימון שהקרב אותחל
                            battleInitialized.current = true;
                            console.log("✅ Battle resumed from saved state during rapid re-init");
                            
                            // סיום טעינה - הקרב מוכן!
                            setIsLoading(false);
                            
                            // לא למחוק את המידע מ-localStorage כדי לשמור אותו למקרה של רימאונט נוסף
                            return;
                        }
                    } catch (error) {
                        console.error("❌ Error resuming battle state:", error);
                        // במקרה של שגיאה, נקה ונמשיך לקרב חדש
                        localStorage.removeItem('activeBattle');
                        localStorage.removeItem('battleNavigationLocked');
                        localStorage.removeItem('battleInitTime');
                        localStorage.removeItem('battleInstanceTime');
                    }
                } else if (savedBattleState) {
                    // יש קרב ישן - טען אותו אם הוא לא הסתיים
                    try {
                        const battleState = JSON.parse(savedBattleState);
                        if (battleState.winLose) {
                            console.log("🧹 Cleaning up old completed battle");
                            localStorage.removeItem('activeBattle');
                            localStorage.removeItem('battleNavigationLocked');
                            localStorage.removeItem('battleInitTime');
                            localStorage.removeItem('battleInstanceTime');
                            // Don't navigate here - let the new battle start
                        } else {
                            // קרב פעיל - טען אותו
                            console.log("⚠️ Active battle found - resuming from saved state");
                            
                            // בדוק אם זה אותו סוג קרב
                            const isSameBattleType = (battleState.isMapBattle && isMapBattle) || 
                                                     (!battleState.isMapBattle && !isMapBattle);
                            
                            if (isSameBattleType) {
                                // אתחול הקרב עם הנתונים המשוחזרים
                                // בדיקה שהנתונים תקינים לפני טעינה - חשוב: הפוקימון של האויב חייב להיות תקין
                                if (!battleState.yourPokemon || !battleState.oppPokemon || !battleState.oppPokemon.wild_id) {
                                    console.log("⚠️ Invalid battle state - missing Pokemon data or invalid opponent, starting new battle");
                                    localStorage.removeItem('activeBattle');
                                    localStorage.removeItem('battleNavigationLocked');
                                    localStorage.removeItem('battleInitTime');
                                    localStorage.removeItem('battleInstanceTime');
                                    // המשך לאתחול קרב חדש
                                } else {
                                    setYourPokemon(battleState.yourPokemon);
                                    setOppPokemon(battleState.oppPokemon);
                                    console.log("✅ Restored Pokemon data - Your:", battleState.yourPokemon?.naam, "Opponent:", battleState.oppPokemon?.naam, "wild_id:", battleState.oppPokemon?.wild_id);
                                    // עדכון ההתקפות לפי הפוקימון המשוחזר
                                    if (battleState.yourPokemon) {
                                        updateAttacksForPokemon(battleState.yourPokemon);
                                    } else {
                                        setAttackList(battleState.attackList || attackList);
                                    }
                                    // שחזור מצב התור - חשוב מאוד לשמור את המצב המדויק
                                    setIsPlayerTurn(battleState.isPlayerTurn !== undefined ? battleState.isPlayerTurn : true);
                                    console.log("🔄 Restored player turn state:", battleState.isPlayerTurn);
                                    
                                    // Restore battlePokemons if available - חשוב: לא לאפס HP! Filter to only team Pokemon
                                    if (battleState.battlePokemons && Array.isArray(battleState.battlePokemons)) {
                                        const teamPokemons = battleState.battlePokemons.filter(p => p.opzak === 'ja');
                                        setBattlePokemons(teamPokemons);
                                        console.log("🔍 Restored battlePokemons - filtered to team only:", teamPokemons.length, "out of", battleState.battlePokemons.length);
                                    }
                                    setBattleActive(true);
                                    setLastActionTime(Date.now());
                                    // שחזור טיימר הקרב אם קיים
                                    const savedStartTime = battleState.battleStartTime;
                                    if (savedStartTime) {
                                        const elapsed = Math.floor((Date.now() - savedStartTime) / 1000);
                                        const remaining = Math.max(0, 180 - elapsed);
                                        setBattleStartTime(savedStartTime);
                                        setBattleTimer(remaining);
                                        console.log("⏱️ Battle timer restored:", remaining, "seconds remaining");
                                    } else {
                                        // אם אין זמן שמור, התחל מחדש
                                        setBattleStartTime(Date.now());
                                        setBattleTimer(180);
                                    }
                                    
                                    // סימון שהקרב אותחל
                                    battleInitialized.current = true;
                                    console.log("✅ Battle resumed from saved state");
                                    
                                    // סיום טעינה - הקרב מוכן!
                                    setIsLoading(false);
                                    
                                    // לא למחוק את המידע מ-localStorage כדי לשמור אותו למקרה של רימאונט נוסף
                                    return;
                                }
                            } else {
                                console.log("⚠️ Different battle type - cleaning old battle");
                                localStorage.removeItem('activeBattle');
                                localStorage.removeItem('battleNavigationLocked');
                                localStorage.removeItem('battleInitTime');
                                localStorage.removeItem('battleInstanceTime');
                            }
                        }
                    } catch (error) {
                        // אם יש שגיאה, פשוט נקה הכל
                        console.error("❌ Error parsing saved battle state:", error);
                        localStorage.removeItem('activeBattle');
                        localStorage.removeItem('battleNavigationLocked');
                        localStorage.removeItem('battleInitTime');
                        localStorage.removeItem('battleInstanceTime');
                    }
                }
                
                // קוד לאתחול קרב חדש
                logToFile("Initializing new battle", {
                    isMapBattle,
                    isTrainerBattle,
                    trainerBattleId,
                    mapType,
                    gebied,
                    url: window.location.href
                });
                
                if (isMapBattle) {
                    try {
                        // סימון שהקרב אותחל
                        battleInitialized.current = true;
                        
                        logToFile("Map battle initialization started", {
                            isTrainerBattle,
                            trainerBattleId,
                            mapType,
                            gebied
                        });
                        
                        // Check if this is a trainer battle
                        if (isTrainerBattle && trainerBattleId) {
                            // Load trainer battle data
                            console.log("👤 Loading trainer battle:", trainerBattleId);
                            await logToFile("Trainer battle initialization started", {
                                trainerBattleId,
                                url: window.location.href,
                                searchParams: Object.fromEntries(searchParams.entries())
                            });
                            
                            try {
                                await logToFile("Fetching trainer battle data from API", {
                                    battle_id: trainerBattleId,
                                    endpoint: `${API_ENDPOINTS.GET_TRAINER_BATTLE}?battle_id=${trainerBattleId}`
                                });
                                
                                const apiUrl = `${API_ENDPOINTS.GET_TRAINER_BATTLE}?battle_id=${trainerBattleId}`;
                                let trainerBattleResponse;
                                try {
                                    console.log("📡 Making API call to GET_TRAINER_BATTLE...");
                                    console.log("📡 URL:", apiUrl);
                                    console.log("📡 Battle ID:", trainerBattleId);
                                    
                                    trainerBattleResponse = await axiosInstance.get(apiUrl);
                                    
                                    console.log("✅ API call completed successfully");
                                    console.log("✅ Response status:", trainerBattleResponse?.status);
                                    console.log("✅ Response data:", trainerBattleResponse?.data);
                                    console.log("✅ Response success:", trainerBattleResponse?.data?.success);
                                    
                                    await logToFile("API call completed successfully", {
                                        status: trainerBattleResponse?.status,
                                        hasData: !!trainerBattleResponse?.data,
                                        success: trainerBattleResponse?.data?.success
                                    });
                                } catch (apiError) {
                                    console.error("❌ API call failed!");
                                    console.error("❌ Error message:", apiError.message);
                                    console.error("❌ Error code:", apiError.code);
                                    console.error("❌ Error response:", apiError.response?.data);
                                    console.error("❌ Error status:", apiError.response?.status);
                                    console.error("❌ Full error:", apiError);
                                    
                                    await logToFile("ERROR: API call to GET_TRAINER_BATTLE failed", {
                                        error: apiError.message,
                                        errorResponse: apiError.response?.data,
                                        errorStatus: apiError.response?.status,
                                        errorCode: apiError.code,
                                        errorStack: apiError.stack,
                                        url: apiUrl,
                                        battleId: trainerBattleId
                                    });
                                    
                                    throw apiError;
                                }
                                
                                await logToFile("Trainer battle API response received", {
                                    success: trainerBattleResponse?.data?.success,
                                    hasBattle: !!trainerBattleResponse?.data?.battle,
                                    playerPokemonCount: trainerBattleResponse?.data?.player_pokemon?.length || 0,
                                    trainerPokemonCount: trainerBattleResponse?.data?.trainer_pokemon?.length || 0,
                                    responseStatus: trainerBattleResponse?.status,
                                    responseData: trainerBattleResponse?.data
                                });
                                
                                if (trainerBattleResponse.data && trainerBattleResponse.data.success) {
                                    const battle = trainerBattleResponse.data.battle;
                                    const playerPokes = trainerBattleResponse.data.player_pokemon || [];
                                    const trainerPokes = trainerBattleResponse.data.trainer_pokemon || [];
                                    
                                    await logToFile("Processing trainer battle data", {
                                        battleId: battle.id,
                                        trainerName: battle.trainer_name,
                                        trainerImage: battle.trainer_image,
                                        playerPokemonCount: playerPokes.length,
                                        trainerPokemonCount: trainerPokes.length,
                                        currentPlayerIndex: battle.current_player_pokemon_index,
                                        currentTrainerIndex: battle.current_trainer_pokemon_index
                                    });
                                    
                                    setTrainerBattleData(battle);
                                    setTrainerPokemonList(trainerPokes);
                                    setCurrentTrainerPokemonIndex(battle.current_trainer_pokemon_index || 0);
                                    setTrainerName(battle.trainer_name);
                                    
                                    // Fix trainer image path - handle different formats
                                    let imagePath = battle.trainer_image || '';
                                    if (imagePath) {
                                        // If it already has full path starting with /api, use as is
                                        if (imagePath.startsWith('/api/assets/images/attack/')) {
                                            // Already full path, use as is
                                        } else if (imagePath.startsWith('http')) {
                                            // External URL, use as is
                                        } else {
                                            // Just filename or relative path, add the full path
                                            // Remove any leading slashes first
                                            imagePath = imagePath.replace(/^\/+/, '');
                                            imagePath = `/api/assets/images/attack/${imagePath}`;
                                        }
                                    }
                                    setTrainerImage(imagePath);
                                    
                                    // Set opponent name immediately - we can get player name later if needed
                                    setOppName(battle.trainer_name);
                                    
                                    // Try to get player name from profile (optional - don't block battle if it fails)
                                    // Note: get-player-profile.php requires a 'player' parameter, so we skip it for now
                                    // Player name will be set from elsewhere or can remain empty
                                    
                                    // Convert player pokemon to battle format
                                    const playerPokemonData = playerPokes.map(poke => ({
                                        id: poke.pokemon_id,
                                        naam: poke.name,
                                        level: parseInt(poke.level || 5),
                                        wild_id: parseInt(poke.wild_id || 1),
                                        leven: parseInt(poke.current_hp || poke.max_hp || 100),
                                        levenmax: parseInt(poke.max_hp || poke.current_hp || 100),
                                        origina_level: parseInt(poke.max_hp || poke.current_hp || 100),
                                        type1: poke.type1 || 'Normal',
                                        type2: poke.type2 || '',
                                        attack: parseInt(poke.attack || 50),
                                        defence: parseInt(poke.defence || 50),
                                        speed: parseInt(poke.speed || 50),
                                        'spc.attack': parseInt(poke.spc_attack || 50),
                                        'spc.defence': parseInt(poke.spc_defence || 50),
                                        ability: poke.ability || '',
                                        base_exp: parseInt(poke.base_exp || 100),
                                        attack_base: parseInt(poke.attack_base || 50),
                                        defence_base: parseInt(poke.defence_base || 50),
                                        speed_base: parseInt(poke.speed_base || 50),
                                        'spc.attack_base': parseInt(poke.spc_attack_base || 50),
                                        'spc.defence_base': parseInt(poke.spc_defence_base || 50),
                                        hp_base: parseInt(poke.hp_base || 50),
                                        karakter: 'Hardy',
                                        opzak: 'ja',
                                        aanval_1: poke.aanval_1 || '',
                                        aanval_2: poke.aanval_2 || '',
                                        aanval_3: poke.aanval_3 || '',
                                        aanval_4: poke.aanval_4 || '',
                                        exp: parseInt(poke.exp || 0),
                                        expnodig: parseInt(poke.expnodig || 100)
                                    })).filter(p => p.id > 0); // Filter out invalid pokemon
                                    
                                    // Validate player pokemon data
                                    if (playerPokemonData.length === 0) {
                                        await logToFile("ERROR: No valid player pokemon after filtering", {
                                            playerPokesCount: playerPokes.length,
                                            playerPokemonDataCount: playerPokemonData.length,
                                            battleId: battle.id
                                        });
                                        throw new Error('No valid player Pokemon found in battle');
                                    }
                                    
                                    // Set player pokemon
                                    setBattlePokemons(playerPokemonData);
                                    if (playerPokemonData.length > 0) {
                                        const currentPlayerPoke = playerPokemonData[battle.current_player_pokemon_index || 0];
                                        if (!currentPlayerPoke) {
                                            await logToFile("ERROR: Current player pokemon index out of range", {
                                                currentPlayerIndex: battle.current_player_pokemon_index,
                                                playerPokemonDataCount: playerPokemonData.length
                                            });
                                            throw new Error('Current player Pokemon index out of range');
                                        }
                                        setYourPokemon(currentPlayerPoke);
                                        await logToFile("Player pokemon set successfully", {
                                            pokemonId: currentPlayerPoke.id,
                                            pokemonName: currentPlayerPoke.naam,
                                            pokemonLevel: currentPlayerPoke.level,
                                            pokemonHP: `${currentPlayerPoke.leven}/${currentPlayerPoke.levenmax}`
                                        });
                                    }
                                    
                                    // Convert trainer pokemon to battle format (opponent)
                                    if (trainerPokes.length === 0) {
                                        await logToFile("ERROR: No trainer pokemon found", {
                                            trainerPokesCount: trainerPokes.length,
                                            battleId: battle.id
                                        });
                                        throw new Error('No trainer Pokemon found in battle');
                                    }
                                    
                                    const currentTrainerPoke = trainerPokes[battle.current_trainer_pokemon_index || 0];
                                    if (!currentTrainerPoke) {
                                        await logToFile("ERROR: Current trainer pokemon index out of range", {
                                            currentTrainerIndex: battle.current_trainer_pokemon_index,
                                            trainerPokesCount: trainerPokes.length
                                        });
                                        throw new Error('Current trainer Pokemon index out of range');
                                    }
                                    
                                    const trainerPokemonData = {
                                        id: `trainer-${currentTrainerPoke.id}-${Date.now()}`,
                                        naam: currentTrainerPoke.name,
                                        level: currentTrainerPoke.level,
                                        wild_id: currentTrainerPoke.wild_id,
                                        leven: currentTrainerPoke.current_hp,
                                        levenmax: currentTrainerPoke.max_hp,
                                        origina_level: currentTrainerPoke.max_hp,
                                        type1: currentTrainerPoke.type1,
                                        type2: currentTrainerPoke.type2 || '',
                                        attack: currentTrainerPoke.attack,
                                        defence: currentTrainerPoke.defence,
                                        speed: currentTrainerPoke.speed,
                                        'spc.attack': currentTrainerPoke.spc_attack,
                                        'spc.defence': currentTrainerPoke.spc_defence,
                                        ability: currentTrainerPoke.ability || '',
                                        base_exp: currentTrainerPoke.base_exp || 100,
                                        attack_base: currentTrainerPoke.attack_base || 50,
                                        defence_base: currentTrainerPoke.defence_base || 50,
                                        speed_base: currentTrainerPoke.speed_base || 50,
                                        'spc.attack_base': currentTrainerPoke.spc_attack_base || 50,
                                        'spc.defence_base': currentTrainerPoke.spc_defence_base || 50,
                                        hp_base: currentTrainerPoke.hp_base || 50,
                                        karakter: 'Hardy'
                                    };
                                    setOppPokemon(trainerPokemonData);
                                    
                                    await logToFile("Trainer pokemon set successfully", {
                                        pokemonName: trainerPokemonData.naam,
                                        pokemonLevel: trainerPokemonData.level,
                                        pokemonHP: `${trainerPokemonData.leven}/${trainerPokemonData.levenmax}`
                                    });
                                    
                                    // Set battle data but don't start yet - wait for countdown
                                    setIsLoading(false);
                                    
                                    await logToFile("Trainer battle data loaded successfully, setting countdown", {
                                        playerPokemonDataCount: playerPokemonData.length,
                                        hasOppPokemon: !!trainerPokemonData,
                                        oppPokemonName: trainerPokemonData?.naam,
                                        isLoading: false,
                                        countdownStarting: true
                                    });
                                    
                                    // Start 10 second countdown before battle begins
                                    setTrainerBattleCountdown(10);
                                    
                                    console.log("✅ Trainer battle loaded successfully, starting countdown...");
                                    await logToFile("Trainer battle initialization complete - countdown started", {
                                        countdown: 10,
                                        battleActive: false,
                                        willReturn: true,
                                        shouldNotContinue: true
                                    });
                                    console.log("🛑 Returning from trainer battle initialization - should NOT continue to map battle");
                                    return; // IMPORTANT: This should stop execution and NOT continue to map battle code
                                } else {
                                    await logToFile("Trainer battle API returned unsuccessful response", {
                                        responseData: trainerBattleResponse.data
                                    });
                                    throw new Error('Failed to load trainer battle data');
                                }
                            } catch (trainerError) {
                                console.error("❌ Error loading trainer battle:", trainerError);
                                await logToFile("ERROR: Trainer battle loading failed", {
                                    error: trainerError.message,
                                    errorResponse: trainerError.response?.data,
                                    errorStatus: trainerError.response?.status,
                                    stack: trainerError.stack,
                                    willNavigateTo: '/map'
                                });
                                toast.error(trainerError.response?.data?.error || 'Failed to load trainer battle');
                                setIsLoading(false);
                                setTimeout(() => {
                                    logToFile("Navigating to /map due to trainer battle error", {});
                                    navigate('/map');
                                }, 2000);
                                return;
                            }
                        }
                        
                        // If we reach here and it was a trainer battle, something went wrong
                        if (isTrainerBattle && trainerBattleId) {
                            console.error("⚠️ WARNING: Reached map battle code after trainer battle initialization!");
                            await logToFile("WARNING: Reached map battle code after trainer battle - this should not happen", {
                                isTrainerBattle,
                                trainerBattleId,
                                battleActive,
                                isLoading
                            });
                            // Don't continue with map battle if this was a trainer battle
                            setIsLoading(false);
                            return;
                        }
                        
                        // קבל את סטטוס הריפוי לפני תחילת הקרב
                        let healingPokemonIds = [];
                        await logToFile("Continuing with regular map battle (not trainer battle)", {
                            isTrainerBattle,
                            trainerBattleId,
                            gebied
                        });
                        try {
                            const healingResponse = await axiosInstance.get(API_ENDPOINTS.GET_HEALING_STATUS);
                            if (healingResponse.data && healingResponse.data.success && healingResponse.data.healing_pokemons) {
                                healingPokemonIds = healingResponse.data.healing_pokemons.map(p => parseInt(p.pokemon_id));
                                console.log("🏥 [Battle] Pokemon currently healing:", healingPokemonIds);
                            }
                        } catch (healingError) {
                            console.warn("⚠️ [Battle] Could not fetch healing status:", healingError);
                            // Continue anyway - don't block battle if healing check fails
                        }
                        
                        // קבל את הפוקימונים של השחקן
                        console.log("🔍 Getting player Pokemons for map battle");
                        let allPokemons = await dispatch(getPlayerPokemons()).unwrap();
                        console.log("🔍 Player Pokemons received:", allPokemons);
                        
                        if (!allPokemons || !allPokemons.length) {
                            console.error("❌ No player pokemons found! Data:", allPokemons);
                            await logToFile("ERROR: No player pokemons found in map battle", {
                                allPokemons,
                                isTrainerBattle,
                                trainerBattleId
                            });
                            toast.error(t('No Pokemon found in your team!'));
                            setIsLoading(false);
                            // Don't navigate automatically - let user decide
                            return;
                        }
                        
                        // Filter to only team Pokemon (opzak = 'ja') - not box Pokemon
                        let data = allPokemons.filter(p => p.opzak === 'ja');
                        console.log("🔍 Team Pokemon (after filtering):", data.length, "out of", allPokemons.length, "total Pokemon");
                        
                        if (!data || !data.length) {
                            console.error("❌ No team pokemons found! All pokemons:", allPokemons);
                            await logToFile("ERROR: No team pokemons found (after filtering)", {
                                allPokemonsCount: allPokemons?.length || 0,
                                filteredCount: data?.length || 0,
                                isTrainerBattle,
                                trainerBattleId
                            });
                            toast.error(t('No Pokemon found in your team! Please add Pokemon to your team first.'));
                            setIsLoading(false);
                            // Don't navigate automatically - let user decide
                            return;
                        }
                        
                        // Filter out Pokemon that are currently healing
                        const availablePokemons = data.filter(p => !healingPokemonIds.includes(parseInt(p.id)));
                        
                        if (availablePokemons.length === 0) {
                            console.error("❌ All Pokemon are currently healing!");
                            await logToFile("ERROR: All Pokemon are currently healing", {
                                totalPokemons: data.length,
                                healingPokemonIds,
                                isTrainerBattle,
                                trainerBattleId
                            });
                            toast.error(t('All your Pokemon are currently healing at the hospital! Please wait for them to finish.'));
                            setIsLoading(false);
                            return;
                        }
                        
                        if (availablePokemons.length < data.length) {
                            const healingCount = data.length - availablePokemons.length;
                            toast.warning(t('{{count}} Pokemon are currently healing and cannot participate in battle.', { count: healingCount }));
                        }
                        
                        // Use only available Pokemon (not healing)
                        data = availablePokemons;
                        
                        // קבל פוקימון בר מהאזור שנבחר
                        console.log("🌍 Starting battle in area:", gebied || 'Gras');
                        let wildPokemon;
                        
                        try {
                            // Get point_id from URL if available
                            const urlParams = new URLSearchParams(window.location.search);
                            const pointId = urlParams.get('point_id');
                            
                            // Note: Point validation is now handled by the backend (startMapBattle.php)
                            // If the point is locked, the backend will return an error and we'll handle it below
                            
                            const payload = { 
                                gebied: gebied || 'Gras',
                                point_id: pointId ? parseInt(pointId) : 0
                            };
                            const token = localStorage.getItem('token');
                            
                            await logToFile("Starting map battle", { 
                                gebied: payload.gebied,
                                token: token ? 'EXISTS' : 'MISSING',
                                tokenLength: token ? token.length : 0,
                                url: API_ENDPOINTS.START_MAP_BATTLE
                            });
                            
                            const battleResponse = await axiosInstance.post(API_ENDPOINTS.START_MAP_BATTLE, payload);
                            
                            await logToFile("Map battle response received", { 
                                status: battleResponse?.status,
                                hasData: !!battleResponse?.data,
                                hasSuccess: battleResponse?.data?.success,
                                hasWildPokemon: !!battleResponse?.data?.wild_pokemon,
                                response: battleResponse?.data
                            });
                            
                            if (battleResponse.data && battleResponse.data.success && battleResponse.data.wild_pokemon) {
                                wildPokemon = battleResponse.data.wild_pokemon;
                                // וידוא שיש wild_id תקין - חשוב מאוד!
                                if (!wildPokemon.wild_id) {
                                    console.error("❌ Wild Pokemon missing wild_id, using fallback");
                                    throw new Error('Wild Pokemon missing wild_id');
                                }
                                console.log("✅ Wild Pokemon received from API:", wildPokemon, "wild_id:", wildPokemon.wild_id);
                                await logToFile("Wild Pokemon received successfully", { wildPokemon });
                            } else {
                                throw new Error('Invalid response from battle API - no wild Pokemon');
                            }
                        } catch (error) {
                            console.error("❌ Error getting wild Pokemon from API:", error);
                            await logToFile("Map battle error", { 
                                gebied: gebied || 'Gras',
                                error: error?.message,
                                errorResponse: error?.response?.data,
                                status: error?.response?.status,
                                statusText: error?.response?.statusText,
                                headers: error?.response?.headers,
                                config: {
                                    url: error?.config?.url,
                                    method: error?.config?.method,
                                    hasAuth: !!error?.config?.headers?.Authorization
                                }
                            });
                            
                            const errorMessage = error?.response?.data?.error || error?.message || "Failed to start battle.";
                            
                            // If it's a Fishing rod error, point locked error, or other blocking error, don't start battle
                            if (error?.response?.data?.error && (
                                error.response.data.error.includes('Fishing rod') ||
                                error.response.data.error.includes('No Pokemon found') ||
                                error.response.data.error.includes('No wild Pokemon found') ||
                                error.response.data.error.includes('locked') ||
                                error.response.data.error.includes('locked') ||
                                error.response?.data?.point_locked === true
                            )) {
                                // If point is locked, record loss
                                if (error.response?.data?.point_locked === true) {
                                    try {
                                        const urlParams = new URLSearchParams(window.location.search);
                                        const pointId = urlParams.get('point_id');
                                        const finishPayload = {
                                            result: 'lose',
                                            pokemon_id: data[0]?.id || 0,
                                            enemy_level: 5,
                                            enemy_wild_id: 0,
                                            all_pokemons: data.map(p => ({ id: p.id, hp: p.leven || 0 })),
                                            point_id: pointId ? parseInt(pointId) : 0,
                                            gebied: gebied || ''
                                        };
                                        await axiosInstance.post(API_ENDPOINTS.FINISH_MAP_BATTLE, finishPayload);
                                    } catch (e) {
                                        console.error("Error recording loss:", e);
                                    }
                                }
                                
                                toast.error(errorMessage);
                                setIsLoading(false);
                                // Navigate back to map
                                setTimeout(() => {
                                    navigate('/map');
                                }, 2000);
                                return; // Don't start battle
                            }
                            
                            toast.error(errorMessage + " Using fallback.");
                            
                            // Fallback to random pokemon if API fails (only for non-blocking errors)
                            const randomPokemonId = Math.floor(Math.random() * 150) + 1;
                            const playerPokemon = data[0] || {};
                            const playerLevel = parseInt(playerPokemon.level) || 5;
                            const randomLevel = Math.max(1, Math.floor(playerLevel * (0.7 + Math.random() * 0.6)));
                            const randomHP = 100 + (randomLevel * 8);
                            
                            wildPokemon = {
                                wild_id: randomPokemonId,
                                naam: `Wild Pokemon`,
                                level: randomLevel,
                                leven: randomHP,
                                levenmax: randomHP,
                                type1: 'Normal',
                                type2: ''
                            };
                        }
                        
                        // וידוא שיש wild_id תקין לפני יצירת הפוקימון
                        if (!wildPokemon.wild_id) {
                            console.error("❌ Wild Pokemon missing wild_id, cannot create battle");
                            toast.error(t('Failed to start battle - no wild Pokemon found.'));
                            setIsLoading(false);
                            setTimeout(() => {
                                navigate('/map');
                            }, 2000);
                            return;
                        }
                        
                        const randomPokemon = {
                            id: `wild-${wildPokemon.wild_id}-${Date.now()}`,
                            naam: wildPokemon.naam || `Wild Pokemon #${wildPokemon.wild_id}`,
                            level: wildPokemon.level || 5,
                            wild_id: wildPokemon.wild_id, // חייב להיות קיים!
                            leven: wildPokemon.leven || wildPokemon.levenmax || 100,
                            levenmax: wildPokemon.levenmax || wildPokemon.leven || 100,
                            origina_level: wildPokemon.levenmax || wildPokemon.leven || 100,
                            type1: wildPokemon.type1 || 'Normal',
                            type2: wildPokemon.type2 || '',
                            attack: wildPokemon.attack || 50,
                            defence: wildPokemon.defence || 50,
                            speed: wildPokemon.speed || 50,
                            'spc.attack': wildPokemon['spc.attack'] || 50,
                            'spc.defence': wildPokemon['spc.defence'] || 50,
                            aanval_1: wildPokemon.aanval_1 || '',
                            aanval_2: wildPokemon.aanval_2 || '',
                            aanval_3: wildPokemon.aanval_3 || '',
                            aanval_4: wildPokemon.aanval_4 || '',
                            ability: wildPokemon.ability || '',
                            karakter: wildPokemon.karakter || 'Hardy'
                        };
                        
                        console.log("🔍 Created wild Pokemon from API:", randomPokemon, "wild_id:", randomPokemon.wild_id);
                        
                        // Ensure the player Pokemon has all necessary fields
                        const playerPokemon = data[0] || {};
                        
                        // בדיקה אם יש מצב שמור עם HP מעודכן
                        const savedBattleState = localStorage.getItem('activeBattle');
                        let savedHP = null;
                        if (savedBattleState) {
                            try {
                                const battleState = JSON.parse(savedBattleState);
                                if (battleState.battlePokemons && Array.isArray(battleState.battlePokemons)) {
                                    const savedPokemon = battleState.battlePokemons.find(p => p.id === playerPokemon.id);
                                    if (savedPokemon && savedPokemon.leven !== undefined) {
                                        savedHP = savedPokemon.leven;
                                        console.log("💾 Found saved HP for Pokemon:", playerPokemon.naam, "HP:", savedHP);
                                    }
                                }
                            } catch (e) {
                                console.error("Error reading saved battle state:", e);
                            }
                        }
                        
                        const playerPokemonFixed = {
                            ...playerPokemon,
                            level: parseInt(playerPokemon.level || 5),
                            levenmax: parseInt(playerPokemon.levenmax || 100),
                            leven: savedHP !== null ? savedHP : parseInt(playerPokemon.leven || playerPokemon.levenmax || 100), // Use saved HP if available, else current HP, else max
                            wild_id: parseInt(playerPokemon.wild_id || 1),
                            type1: playerPokemon.type1 || "Normal",
                            type2: playerPokemon.type2 || "",
                            // Ensure exp fields are included
                            exp: parseInt(playerPokemon.exp || playerPokemon['exp'] || 0),
                            expnodig: parseInt(playerPokemon.expnodig || playerPokemon['expnodig'] || 100)
                        };
                        
                        console.log("🔍 Player Pokemon exp data:", {
                            id: playerPokemonFixed.id,
                            exp: playerPokemonFixed.exp,
                            expnodig: playerPokemonFixed.expnodig,
                            expPercentage: playerPokemonFixed.expnodig > 0 ? (playerPokemonFixed.exp / playerPokemonFixed.expnodig * 100).toFixed(2) : 0
                        });
                        
                        // בדיקה אם יש מצב שמור עם HP מעודכן לכל הפוקימונים
                        const savedBattleStateForAll = localStorage.getItem('activeBattle');
                        let savedPokemonsHP = {};
                        if (savedBattleStateForAll) {
                            try {
                                const battleState = JSON.parse(savedBattleStateForAll);
                                if (battleState.battlePokemons && Array.isArray(battleState.battlePokemons)) {
                                    battleState.battlePokemons.forEach(p => {
                                        if (p.id && p.leven !== undefined) {
                                            savedPokemonsHP[p.id] = p.leven;
                                        }
                                    });
                                    console.log("💾 Found saved HP for", Object.keys(savedPokemonsHP).length, "Pokemons");
                                }
                            } catch (e) {
                                console.error("Error reading saved battle state:", e);
                            }
                        }
                        
                        // Initialize battle pokemons list with all team pokemons only
                        // Double-check that we only include team Pokemon (opzak = 'ja')
                        const allTeamPokemons = data
                            .filter(p => p.opzak === 'ja') // Ensure only team Pokemon
                            .map(p => {
                                const savedHP = savedPokemonsHP[p.id];
                                return {
                                    ...p,
                                    level: parseInt(p.level || 5),
                                    levenmax: parseInt(p.levenmax || 100),
                                    leven: savedHP !== null && savedHP !== undefined ? savedHP : parseInt(p.leven || p.levenmax || 100), // Use saved HP if available, else current HP, else max
                                    wild_id: parseInt(p.wild_id || 1),
                                    type1: p.type1 || "Normal",
                                    type2: p.type2 || "",
                                    // Ensure exp fields are included for all pokemons
                                    exp: parseInt(p.exp || p['exp'] || 0),
                                    expnodig: parseInt(p.expnodig || p['expnodig'] || 100),
                                    opzak: 'ja' // Ensure opzak is set correctly
                                };
                            });
                        console.log("🔍 Initialized battlePokemons with", allTeamPokemons.length, "team Pokemon");
                        setBattlePokemons(allTeamPokemons);
                        
                        // בדיקה אם הפוקימון הראשון חסר חיים או ב-healing - אם כן, מצא פוקימון זמין
                        let selectedPokemon = playerPokemonFixed;
                        const isSelectedPokemonHealing = healingPokemonIds.includes(parseInt(selectedPokemon.id));
                        
                        if (selectedPokemon.leven <= 0 || isSelectedPokemonHealing) {
                            console.log(`⚠️ First Pokemon has ${selectedPokemon.leven <= 0 ? '0 HP' : 'HP > 0'} ${isSelectedPokemonHealing ? 'and is healing' : ''}, finding available Pokemon`);
                            const availablePokemon = allTeamPokemons.find(p => 
                                p.leven > 0 && !healingPokemonIds.includes(parseInt(p.id))
                            );
                            if (availablePokemon) {
                                selectedPokemon = availablePokemon;
                                console.log("✅ Switching to available Pokemon:", selectedPokemon.naam);
                            } else {
                                // כל הפוקימונים חסרי חיים או ב-healing - הקרב מסתיים בהפסד
                                console.log("❌ All Pokemon have 0 HP or are healing - battle lost");
                                setWinLose('lose');
                                setIsLoading(false);
                                if (isMapBattle) {
                                    handleBattleFinish('lose');
                                    setTimeout(() => {
                                        navigate('/hospital');
                                    }, 2000);
                                }
                                return;
                            }
                        }
                        
                        console.log("🔍 Player Pokemon set:", selectedPokemon);
                        console.log("🔍 All battle pokemons initialized:", allTeamPokemons.length);
                        
                        // שמות התקפה אקראיים
                        const attackNames = [
                            "Punch", "Kick", "Slam", "Tackle", "Quick Attack",
                            "Thunderbolt", "Flamethrower", "Water Gun", "Razor Leaf", "Ice Beam",
                            "Psybeam", "Shadow Ball", "Earthquake", "Aerial Ace", "Dragon Claw",
                            "Hyper Beam", "Solar Beam", "Hydro Pump", "Fire Blast", "Thunder"
                        ];
                        
                        // פונקציה לבחירת שם התקפה אקראי
                        const getRandomAttackName = () => {
                            return attackNames[Math.floor(Math.random() * attackNames.length)];
                        };
                        
                        // יצירת התקפות אקראיות - זה לא בשימוש כי יש קריאה ל-updateAttacksForPokemon
                        // אבל נשאיר את זה למקרה של fallback
                        const randomAttacks = [
                            {
                                name: getRandomAttackName(),
                                minDamage: 30,
                                maxDamage: 50,
                                type: "Normal"
                            },
                            {
                                name: getRandomAttackName(),
                                minDamage: 50,
                                maxDamage: 70,
                                type: playerPokemonFixed.type1 || "Normal"
                            },
                            {
                                name: getRandomAttackName(),
                                minDamage: 70,
                                maxDamage: 100,
                                type: randomPokemon.type1 || "Normal"
                            }
                        ];
                        
                        // אתחול מצב הקרב
                        // עדכון ההתקפות לפי הפוקימון שנבחר (לא הראשון)
                        updateAttacksForPokemon(selectedPokemon);
                        setYourPokemon(selectedPokemon);
                        setOppPokemon(randomPokemon);
                        // Save original URL when battle starts
                        originalURLRef.current = window.location.href;
                        
                        setBattleActive(true);
                        setLastActionTime(Date.now());
                        // התחלת טיימר הקרב - 3 דקות
                        setBattleStartTime(Date.now());
                        setBattleTimer(180); // 3 minutes = 180 seconds
                        
                        // וידוא שהשחקן תמיד מתחיל ראשון לפי הדרישה
                        setIsPlayerTurn(true);
                        console.log("👤 Player always goes first - turn set to player");
                        
                        // סיום טעינה - הקרב מוכן!
                        setIsLoading(false);
                        
                        // שמירת מצב הקרב
                        setTimeout(() => {
                            if (componentMounted.current) {
                                console.log("💾 Saving initial battle state");
                                updateBattleState({ forceUpdate: true });
                            }
                        }, 500);
                    } catch (error) {
                        console.error("Error initializing map battle:", error);
                        setIsLoading(false); // גם במקרה של שגיאה - סיים טעינה
                        // אין לצאת מהקרב גם במקרה של שגיאה
                    }
                } else {
                    // קרב דו-קרב - אתחול רגיל
                    try {
                        await getDualData();
                        battleInitialized.current = true;
                        // Save original URL when battle starts
                        originalURLRef.current = window.location.href;
                        
                        setBattleActive(true);
                        setLastActionTime(Date.now());
                        // התחלת טיימר הקרב - 3 דקות (גם בקרב דו-קרב)
                        setBattleStartTime(Date.now());
                        setBattleTimer(180); // 3 minutes = 180 seconds
                        // וידוא שהשחקן תמיד מתחיל ראשון גם בקרב דו-קרב
                        setIsPlayerTurn(true);
                        // סיום טעינה
                        setIsLoading(false);
                    } catch (error) {
                        console.error("Error initializing dual battle:", error);
                        setIsLoading(false); // גם במקרה של שגיאה - סיים טעינה
                        // אין לצאת מהקרב גם במקרה של שגיאה
                    }
                }
            } catch (error) {
                console.error("Fatal error in battle initialization:", error);
                // לא נצא מהקרב גם במקרה של שגיאה חמורה
            }
        };
        
        // הפעלת אתחול הקרב רק בטעינה הראשונית
        if (isFirstLoad.current) {
            isFirstLoad.current = false;
            handleInitialBattle();
        }

        // מערכת ה-interval לעדכונים
        const intervalId = setInterval(() => {
            // עדכון הזמן הנוכחי פעם אחת לכל מחזור
            const currentTime = Date.now();
            
            // בדיקה למעקב על מצב הקרב בתדירות נמוכה יותר
            if (currentTime % 3000 < 1000) {  // רק פעם ב-3 שניות בערך
                console.log("⏱️ Battle interval check - active:", battleActive, "player turn:", isPlayerTurn, 
                        "attacking:", attacking, "oppAttacking:", oppAttacking, "winLose:", winLose,
                        "lastAction:", Math.floor((currentTime - lastActionTime)/1000) + "s ago");
            }
            
            // עדכון אוטומטי של מצב הקרב כל 2 שניות - הגנה 1: שמירה אוטומטית
            const timeSinceLastUpdate = currentTime - lastActionTime;
            if (timeSinceLastUpdate > 2000) {
                // שמירה עם flagging שזו פעולה מתוזמנת אוטומטית
                updateBattleState({ autoSave: true, battleStartTime, battleTimer });
                
                // אל תעדכן את זמן הפעולה האחרונה כאן כדי לא להפריע למנגנון ההתקפות האוטומטיות
                // אבל כן נעדכן במקרה שיש חוסר תגובה ארוך מאוד
                if (timeSinceLastUpdate > 20000) {
                    console.log("⚠️ Long period of inactivity detected - resetting action timer");
                    setLastActionTime(currentTime);
                }
            }
            
            // בדיקת התקפות בקרב דו-קרב - לא משנים כי זה לא חלק מהבעיה
            if (!isMapBattle && duel_data?.id && battleActive) {
                if (timeSinceLastUpdate > 5000) {
                    try {
                        attckLog();
                    } catch (error) {
                        console.error("Error checking attack log:", error);
                    }
                }
            }
            
            // התקפה אוטומטית של האויב בקרב מפה
            if (isMapBattle && battleActive && !isPlayerTurn && !attacking && !oppAttacking && !winLose) {
                // המתנה ארוכה יותר לפני התקפת האויב כדי לאפשר לשחקן לראות את המצב
                if (timeSinceLastUpdate > 3000) {
                    try {
                        console.log("⚔️ Enemy is attacking automatically");
                        
                        // עדכון מיידי של lastActionTime כדי למנוע תקיפה כפולה
                        setLastActionTime(currentTime);
                        
                        const attackTypes = ["Normal", "Fire", "Water", "Electric"];
                        const randomType = attackTypes[Math.floor(Math.random() * attackTypes.length)];
                        
                        let damage;
                        if (isTrainerBattle && oppPokemon && oppPokemon.attack) {
                            // בקרב מאמן: חישוב לפי הנוסחה המפורטת
                            const enemyLevel = oppPokemon.level || 50;
                            const enemyAttackBase = oppPokemon.attack_base || 50;
                            const enemySpAttackBase = oppPokemon?.['spc.attack_base'] || oppPokemon?.spc_attack_base || 50;
                            const playerDefenceBase = yourPokemon?.defence_base || 50;
                            const playerSpDefenceBase = yourPokemon?.['spc.defence_base'] || yourPokemon?.spc_defence_base || 50;
                            const playerLevel = yourPokemon?.level || 50;
                            
                            // חישוב Attack ו-Defence לפי הנוסחה
                            const enemyAttack = enemyAttackBase * (1 + enemyLevel / 50);
                            const enemySpAttack = enemySpAttackBase * (1 + enemyLevel / 50);
                            const playerDefence = playerDefenceBase * (1 + playerLevel / 50);
                            const playerSpDefence = playerSpDefenceBase * (1 + playerLevel / 50);
                            
                            // החלטה אם זו התקפה פיזית או מיוחדת לפי סוג המתקפה
                            const attackType = randomType;
                            const isPhysicalAttack = ['Normal', 'Fighting', 'Flying', 'Poison', 'Ground', 'Rock', 'Bug', 'Ghost', 'Steel'].includes(attackType);
                            const attackStat = isPhysicalAttack ? enemyAttack : enemySpAttack;
                            const defenceStat = isPhysicalAttack ? playerDefence : playerSpDefence;
                            
                            // BasePower - ערך ברירת מחדל
                            const basePower = 50;
                            
                            // Modifier = TypeEffect * Crit * Random
                            const defenderType1 = yourPokemon?.type1 || 'Normal';
                            const defenderType2 = yourPokemon?.type2 || null;
                            const typeMultiplier = getTypeEffectiveness(attackType, defenderType1, defenderType2);
                            const critChance = 0.0625;
                            const isCrit = Math.random() < critChance;
                            const critMultiplier = isCrit ? 1.5 : 1.0;
                            const randomMultiplier = 0.85 + Math.random() * 0.25;
                            
                            const modifier = typeMultiplier * critMultiplier * randomMultiplier;
                            
                            // Damage = ((Attack / Defence) * BasePower * Modifier)
                            damage = Math.max(1, Math.floor((attackStat / Math.max(1, defenceStat)) * basePower * modifier));
                            console.log("⚡ Trainer Battle Auto Attack - Formula:", attackStat.toFixed(2), "/", defenceStat.toFixed(2), "*", basePower, "*", modifier.toFixed(3), "=", damage);
                        } else {
                            // נזק מותאם לרמת המפלצת - חזק יותר כדי לאתגר את השחקן
                            const baseDamage = 15;
                            const levelBonus = Math.floor(oppPokemon.level * 1.5);
                            const randomVariation = Math.floor(Math.random() * 20) + 10;
                            const hpRatio = (oppPokemon.leven || 0) / (oppPokemon.levenmax || 100);
                            const healthBonus = Math.floor((1 - hpRatio) * 20);
                            damage = Math.floor((baseDamage + levelBonus + randomVariation + healthBonus) * 1.2);
                        }
                        
                        const wildAttack = {
                            name: 'Auto Attack',
                            damage: damage,
                            type: randomType
                        };
                        
                        console.log("🎯 Enemy auto attack:", wildAttack);
                        
                        if (componentMounted.current) {
                            opp_attack(wildAttack);
                        } else {
                            console.log("⚠️ Component unmounted - canceling auto attack");
                        }
                    } catch (error) {
                        console.error("❌ Error in enemy auto attack:", error);
                        
                        // במקרה של שגיאה, החזר את התור לשחקן
                        setIsPlayerTurn(true);
                        setLastActionTime(currentTime);
                        toast.info(t('Your turn to attack!'));
                    }
                }
            }
            
            // בדיקת "תקיעות" במשחק - רק אם התור של היריב ולא מתבצעת התקפה
            if (isMapBattle && battleActive && !isPlayerTurn && !oppAttacking && !attacking && !winLose) {
                // אחרי 8 שניות של חוסר פעילות, החזר את התור לשחקן
                if (timeSinceLastUpdate > 8000) {
                    console.log("⚠️ Battle seems stuck, resetting player's turn");
                    setIsPlayerTurn(true);
                    setLastActionTime(currentTime);
                    toast.info(t('Your turn to attack! The opponent is delayed.'));
                }
            }
            
            // וידוא שהנעילה פעילה כל עוד הקרב פעיל
            if (battleActive && !winLose && !navigationLocked) {
                console.log("🔒 Re-locking navigation during battle");
                setNavigationLocked(true);
            }
        }, 1000);
        
        // הוספת האזנה לאירוע יציאה מהדף - מוסר לפי בקשת המשתמש
        // המשתמש יכול לצאת מתי שהוא רוצה, לא צריך להפריע לו
        // const handleBeforeUnload = (e) => {
        //     // Disabled - user requested no popup
        // };
        
        // window.addEventListener('beforeunload', handleBeforeUnload);
        
        // עדכון הנעילה בלוקאלסטורג' במקום useEffect פנימי
        const updateNavigationLockInLocalStorage = () => {
            // שמירת מצב הנעילה ב-localStorage
            if (battleActive && !winLose) {
                console.log("🔒 Setting navigation lock in localStorage");
                localStorage.setItem('battleNavigationLocked', 'true');
            } else if (winLose) {
                console.log("🔓 Clearing navigation lock in localStorage");
                localStorage.removeItem('battleNavigationLocked');
            }
        };
        
        // קריאה לפונקציה במקום useEffect פנימי
        updateNavigationLockInLocalStorage();
        
        // בדוק את תקינות הקרב והיכולת לנווט
        const checkNavigationLock = () => {
            // אם הקרב פעיל, ודא שהנעילה פעילה גם
            if (battleActive && !winLose) {
                if (!navigationLocked) {
                    console.log("🔒 Re-locking navigation during active battle");
                    setNavigationLocked(true);
                }
            }
            
            // בדיקה נוספת מ-localStorage למקרה שמשהו ניסה לשנות את המצב
            const storedLock = localStorage.getItem('battleNavigationLocked');
            if (storedLock === 'true' && !navigationLocked) {
                console.log("🔒 Restoring navigation lock from localStorage");
                setNavigationLocked(true);
            }
        };
        
        // בדיקה תקופתית של מצב הנעילה
        const lockCheckInterval = setInterval(checkNavigationLock, 500);
        
        // ניקוי משתנים בעת פירוק הקומפוננטה
        return () => {
            console.log("♻️ Battle component unmounting. Manual exit:", manualExit.current);
            clearInterval(intervalId);
            clearInterval(lockCheckInterval);
            // window.removeEventListener('beforeunload', handleBeforeUnload); // Removed since we removed the listener
            
            if (!manualExit.current) {
                // שמירת מצב הקרב אם לא יצאנו באופן מכוון
                // Save current Pokemon's HP before unmounting
                if (yourPokemon && yourPokemon.id) {
                    setBattlePokemons(prev => prev.map(p => 
                        p.id === yourPokemon.id ? { ...p, leven: yourPokemon.leven } : p
                    ));
                }
                updateBattleState({ isNewBattle: true });
            } else {
                localStorage.removeItem('activeBattle');
            }
            
            // לפני ניקוי, נסמן שהקומפוננטה נפרקה
            componentMounted.current = false;
        };
    }, [yourPokemon, oppPokemon, isPlayerTurn, battleActive, attackList, winLose, duel_data, navigationLocked, isMapBattle, searchParams]);

    // הגנה 3: טיימר של 3 דקות - כשמגיע ל-0 הקרב מסתיים והשחקן מפסיד
    useEffect(() => {
        if (!battleActive || winLose || !battleStartTime) return;
        
        const interval = setInterval(() => {
            if (!battleActive || winLose) {
                clearInterval(interval);
                return;
            }
            
            const elapsed = Math.floor((Date.now() - battleStartTime) / 1000);
            const remaining = Math.max(0, 180 - elapsed);
            setBattleTimer(remaining);
            
                // אם הטיימר הגיע ל-0, הקרב מסתיים בהפסד
                if (remaining === 0) {
                    console.log("⏰ Battle timer expired - player loses");
                    clearInterval(interval);
                    setWinLose('lose');
                    setBattleActive(false);
                    
                    // אם זה קרב מפה, שלח תוצאה לשרת - חשוב: לשלוח את ה-HP המעודכן
                    if (isMapBattle && yourPokemon?.id) {
                        // עדכון ה-HP של הפוקימון הנוכחי לפני שליחה
                        setBattlePokemons(prev => prev.map(p => 
                            p.id === yourPokemon.id ? { ...p, leven: yourPokemon.leven } : p
                        ));
                        // המתנה קצרה כדי לוודא שהמצב עודכן
                        setTimeout(() => {
                            handleBattleFinish('lose').catch(err => {
                                console.error("Error finishing battle:", err);
                            });
                        }, 100);
                    }
                    
                    // ניקוי localStorage
                    localStorage.removeItem('activeBattle');
                    localStorage.removeItem('battleNavigationLocked');
                    localStorage.removeItem('battleInitTime');
                    localStorage.removeItem('battleInstanceTime');
                    
                    toast.error(t('Battle time expired! You lost.'));
                }
        }, 1000);
        
        return () => clearInterval(interval);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [battleActive, winLose, battleStartTime, isMapBattle]);

    // Trainer battle countdown effect
    useEffect(() => {
        if (trainerBattleCountdown !== null && trainerBattleCountdown > 0) {
            logToFile("Trainer battle countdown started", {
                countdown: trainerBattleCountdown,
                trainerName,
                trainerImage
            });
            
            const countdownInterval = setInterval(() => {
                setTrainerBattleCountdown(prev => {
                    if (prev <= 1) {
                        // Countdown finished, start the battle
                        console.log("🎯 Countdown finished - initializing trainer battle");
                        
                        // Initialize battle properly - same as regular map battle
                        // Update attacks for player pokemon
                        if (yourPokemon && yourPokemon.id) {
                            updateAttacksForPokemon(yourPokemon);
                        }
                        
                        // Save original URL when battle starts
                        originalURLRef.current = window.location.href;
                        
                        // Set battle active and initialize battle state
                        setBattleActive(true);
                        setLastActionTime(Date.now());
                        setBattleStartTime(Date.now());
                        setBattleTimer(180); // 3 minutes
                        setIsPlayerTurn(true); // Player always goes first
                        
                        console.log("✅ Trainer battle initialized - ready to fight!");
                        
                        return null;
                    }
                    return prev - 1;
                });
            }, 1000);
            
            return () => clearInterval(countdownInterval);
        }
    }, [trainerBattleCountdown, trainerName, trainerImage, yourPokemon]);

    useEffect(() => {
        // הוספת סגנונות CSS למסמך עבור הפופאפים - עיצוב modal במרכז המסך
        const styleElement = document.createElement('style');
        styleElement.innerHTML = `
            .win-class, .lose-class {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 10000;
                animation: fadeIn 0.5s;
                display: flex;
                justify-content: center;
                align-items: center;
            }
            
            .win-class .modal_area, .lose-class .modal_area {
                position: relative;
                padding: 0;
                width: 100%;
                z-index: 999999;
                background: #00000096;
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100%;
            }
            
            .win-class .modal_content, .lose-class .modal_content {
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
            }
            
            .win-class .modal_button, .lose-class .modal_button {
                position: relative;
                text-align: center;
                display: flex;
                flex-direction: column;
                align-items: center;
            }
            
            .win-class .modal_btn, .lose-class .modal_btn {
                display: inline-block;
                text-decoration: none;
                position: relative;
            }
            
            .win-class .modal_btn img, .lose-class .modal_btn img {
                width: 700px;
                margin: 0 auto;
                display: block;
            }
            
            .lose-class .modal_btn img {
                filter: hue-rotate(-113deg);
            }
            

            
            .win-class .battle-result-button, .lose-class .battle-result-button {
                margin-top: 20px;
                padding: 0;
                font-size: 20px;
                font-weight: 700;
                border: none;
                background: transparent;
                cursor: pointer;
                transition: all 0.3s ease;
                text-decoration: underline;
                color: #fff;
                display: inline-block;
            }
            
            .win-class .battle-result-button:hover, .lose-class .battle-result-button:hover {
                opacity: 0.8;
            }
            
            /* RTL support for Hebrew */
            .win-class[dir="rtl"], .lose-class[dir="rtl"] {
                direction: rtl;
            }
            
            .win-class[dir="rtl"] .modal_button,
            .lose-class[dir="rtl"] .modal_button {
                direction: rtl;
            }
            
            .win-class[dir="rtl"] .modal_button a p,
            .lose-class[dir="rtl"] .modal_button a p {
                direction: rtl;
                text-align: center;
            }
            
            .win-class[dir="rtl"] .battle-result-button,
            .lose-class[dir="rtl"] .battle-result-button {
                direction: rtl;
                text-align: center;
            }
            
            @keyframes fadeIn {
                from { opacity: 0; }
                to { opacity: 1; }
            }
        `;
        document.head.appendChild(styleElement);
        
        return () => {
            // ניקוי הסגנונות בעת פירוק הקומפוננטה
            if (document.head.contains(styleElement)) {
                document.head.removeChild(styleElement);
            }
        };
    }, []);

    useEffect(() => {
        // כאשר יש ניצחון או הפסד, נשמיע צליל מתאים וננקה את מצב הקרב
        if (winLose === 'win') {
            console.log('Victory!');
            // אם יש אפשרות, כאן אפשר להוסיף השמעת צליל ניצחון
            
            // Clean up battle state after a delay to allow user to see victory screen
            setTimeout(() => {
                localStorage.removeItem('activeBattle');
                localStorage.removeItem('battleNavigationLocked');
                localStorage.removeItem('battleInitTime');
                localStorage.removeItem('battleInstanceTime');
            }, 5000); // Clean up after 5 seconds
        } else if (winLose === 'lose') {
            console.log('Defeat!');
            // אם יש אפשרות, כאן אפשר להוסיף השמעת צליל הפסד
            
            // Clean up battle state after a delay to allow user to see defeat screen
            setTimeout(() => {
                localStorage.removeItem('activeBattle');
                localStorage.removeItem('battleNavigationLocked');
                localStorage.removeItem('battleInitTime');
                localStorage.removeItem('battleInstanceTime');
            }, 5000); // Clean up after 5 seconds
        }
    }, [winLose]);

    useEffect(() => {
        // if (name == 1) {
        //     setYourPokemon(pokemons[0])
        //     setOppPokemon(pokemons[1])
        // } else {
        //     setYourPokemon(pokemons[1])
        //     setOppPokemon(pokemons[0])
        // }
        // const websocket = new WebSocket('ws://localhost:3000');

        // websocket.onopen = () => {
        //     console.log('open');
        // }

        // websocket.onmessage = (event) => {
        //     setOppAttacking(true);
        //     const data = JSON.parse(event.data);
        //     if (data.type === 'attack') {
        //         opp_attack(data.damage)
        //     }
        // }
        // websocket.onclose = () => {
        //     console.log('WebSocket closed');
        // };
        // setWs(websocket);
        // return () => {
        //     websocket.close();
        // };

    }, [pokemons])
    // const selectName = (name) => {
    //     setName(name)
    //     setOppName(name == 1 ? 2 : 1)

    //     const registrationMessage = JSON.stringify({
    //         type: 'register',
    //         name: name,
    //     });
    //     ws.send(registrationMessage);
    // }

    // פונקציה שמחזירה את שם קובץ התמונה המתאים לסוג התקפה
    const getAttackTypeImage = (type) => {
        // מחלקת סוגי התקפות לקבצי תמונה מוכרים
        const validTypes = {
            'normal': 'Normal.png',
            'fire': 'Fire.png',
            'water': 'Water.png',
            'electric': 'Electric.png',
            'grass': 'Grass.png',
            'ice': 'Ice.png',
            'fighting': 'Fighting.png',
            'poison': 'Poison.png',
            'ground': 'Ground.png',
            'flying': 'Flying.png',
            'psychic': 'Psychic.png',
            'bug': 'Bug.png',
            'rock': 'Rock.png',
            'ghost': 'Ghost.png',
            'dragon': 'Dragon.png',
            'dark': 'Dark.png',
            'steel': 'Steel.png',
            'fairy': 'Fairy.png'
        };
        
        // נרמול הסוג לאותיות קטנות
        const normalizedType = typeof type === 'string' ? type.toLowerCase() : 'normal';
        
        // החזרת שם הקובץ המתאים או קובץ ברירת מחדל
        return validTypes[normalizedType] || 'Normal.png';
    };
    
    // 🎯 חישוב יתרון סוג התקפה - כמו במשחקי פוקימון אמיתיים
    // Type Effectiveness Chart - returns multiplier (0, 0.5, 1, or 2)
    const getTypeEffectiveness = (attackType, defenderType1, defenderType2 = null) => {
        // טבלת יתרונות וחולשות סוגים - מבוססת על Pokemon
        const typeChart = {
            // Normal
            'normal': { 'rock': 0.5, 'ghost': 0, 'steel': 0.5 },
            // Fire - חזק נגד: דשא, קרח, באג, מתכת. חלש נגד: מים, סלע, אש, דרקון
            'fire': { 'fire': 0.5, 'water': 0.5, 'grass': 2, 'ice': 2, 'bug': 2, 'rock': 0.5, 'dragon': 0.5, 'steel': 2 },
            // Water - חזק נגד: אש, קרקע, סלע. חלש נגד: מים, דשא, דרקון
            'water': { 'fire': 2, 'water': 0.5, 'grass': 0.5, 'ground': 2, 'rock': 2, 'dragon': 0.5 },
            // Electric - חזק נגד: מים, עפיפה. חלש נגד: חשמל, דשא, דרקון. לא יעיל נגד: קרקע
            'electric': { 'water': 2, 'electric': 0.5, 'grass': 0.5, 'ground': 0, 'flying': 2, 'dragon': 0.5 },
            // Grass - חזק נגד: מים, קרקע, סלע. חלש נגד: אש, דשא, רעל, עפיפה, באג, דרקון, מתכת
            'grass': { 'fire': 0.5, 'water': 2, 'grass': 0.5, 'poison': 0.5, 'ground': 2, 'flying': 0.5, 'bug': 0.5, 'rock': 2, 'dragon': 0.5, 'steel': 0.5 },
            // Ice - חזק נגד: דשא, קרקע, עפיפה, דרקון. חלש נגד: אש, מים, קרח, מתכת
            'ice': { 'fire': 0.5, 'water': 0.5, 'grass': 2, 'ice': 0.5, 'ground': 2, 'flying': 2, 'dragon': 2, 'steel': 0.5 },
            // Fighting - חזק נגד: נורמל, קרח, סלע, חושך, מתכת. חלש נגד: רעל, עפיפה, פסיכי, באג, פיות. לא יעיל נגד: רוח
            'fighting': { 'normal': 2, 'ice': 2, 'poison': 0.5, 'flying': 0.5, 'psychic': 0.5, 'bug': 0.5, 'rock': 2, 'ghost': 0, 'dark': 2, 'steel': 2, 'fairy': 0.5 },
            // Poison - חזק נגד: דשא, פיות. חלש נגד: רעל, קרקע, סלע, רוח. לא יעיל נגד: מתכת
            'poison': { 'grass': 2, 'poison': 0.5, 'ground': 0.5, 'rock': 0.5, 'ghost': 0.5, 'steel': 0, 'fairy': 2 },
            // Ground - חזק נגד: אש, חשמל, רעל, סלע, מתכת. חלש נגד: דשא, באג. לא יעיל נגד: עפיפה
            'ground': { 'fire': 2, 'electric': 2, 'grass': 0.5, 'poison': 2, 'flying': 0, 'bug': 0.5, 'rock': 2, 'steel': 2 },
            // Flying - חזק נגד: דשא, קרב, באג. חלש נגד: חשמל, סלע, מתכת
            'flying': { 'electric': 0.5, 'grass': 2, 'fighting': 2, 'bug': 2, 'rock': 0.5, 'steel': 0.5 },
            // Psychic - חזק נגד: קרב, רעל. חלש נגד: פסיכי, מתכת. לא יעיל נגד: חושך
            'psychic': { 'fighting': 2, 'poison': 2, 'psychic': 0.5, 'dark': 0, 'steel': 0.5 },
            // Bug - חזק נגד: דשא, פסיכי, חושך. חלש נגד: אש, קרב, רעל, עפיפה, רוח, מתכת, פיות
            'bug': { 'fire': 0.5, 'grass': 2, 'fighting': 0.5, 'poison': 0.5, 'flying': 0.5, 'psychic': 2, 'ghost': 0.5, 'dark': 2, 'steel': 0.5, 'fairy': 0.5 },
            // Rock - חזק נגד: אש, קרח, עפיפה, באג. חלש נגד: קרב, קרקע, מתכת
            'rock': { 'fire': 2, 'ice': 2, 'fighting': 0.5, 'ground': 0.5, 'flying': 2, 'bug': 2, 'steel': 0.5 },
            // Ghost - חזק נגד: פסיכי, רוח. חלש נגד: חושך. לא יעיל נגד: נורמל
            'ghost': { 'normal': 0, 'psychic': 2, 'ghost': 2, 'dark': 0.5 },
            // Dragon - חזק נגד: דרקון. חלש נגד: מתכת. לא יעיל נגד: פיות
            'dragon': { 'dragon': 2, 'steel': 0.5, 'fairy': 0 },
            // Dark - חזק נגד: פסיכי, רוח. חלש נגד: קרב, חושך, פיות
            'dark': { 'fighting': 0.5, 'psychic': 2, 'ghost': 2, 'dark': 0.5, 'fairy': 0.5 },
            // Steel - חזק נגד: קרח, סלע, פיות. חלש נגד: אש, מים, חשמל, מתכת
            'steel': { 'fire': 0.5, 'water': 0.5, 'electric': 0.5, 'ice': 2, 'rock': 2, 'steel': 0.5, 'fairy': 2 },
            // Fairy - חזק נגד: קרב, דרקון, חושך. חלש נגד: אש, רעל, מתכת
            'fairy': { 'fire': 0.5, 'fighting': 2, 'poison': 0.5, 'dragon': 2, 'dark': 2, 'steel': 0.5 }
        };
        
        // נרמול הסוגים לאותיות קטנות
        const atkType = (attackType || 'normal').toLowerCase();
        const defType1 = (defenderType1 || 'normal').toLowerCase();
        const defType2 = defenderType2 ? defenderType2.toLowerCase() : null;
        
        // קבלת המכפיל מהטבלה
        let multiplier = 1;
        
        // בדיקת יתרון מול סוג ראשון
        if (typeChart[atkType] && typeChart[atkType][defType1] !== undefined) {
            multiplier *= typeChart[atkType][defType1];
        }
        
        // בדיקת יתרון מול סוג שני (אם קיים)
        if (defType2 && typeChart[atkType] && typeChart[atkType][defType2] !== undefined) {
            multiplier *= typeChart[atkType][defType2];
        }
        
        return multiplier;
    };
    
    // קבלת הודעת יתרון סוג להצגה
    const getTypeEffectivenessMessage = (multiplier) => {
        if (multiplier === 0) return { text: t("It doesn't affect..."), color: '#888888' };
        if (multiplier <= 0.25) return { text: t("It's barely effective..."), color: '#ff6666' };
        if (multiplier === 0.5) return { text: t("It's not very effective..."), color: '#ffaa00' };
        if (multiplier === 2) return { text: t("It's super effective!"), color: '#00ff00' };
        if (multiplier >= 4) return { text: t("It's extremely effective!!"), color: '#00ffff' };
        return null; // normal effectiveness - no message
    };

    // עדכון ושמירת מצב הקרב ב-localStorage
    const updateBattleState = (extraState = {}) => {
        try {
            // אם הקרב לא אותחל, אין מה לשמור
            if (!battleInitialized.current && !extraState.forceUpdate) {
                console.log("⚠️ Not saving - battle not fully initialized");
                return null;
            }
            
            // אם הקומפוננטה כבר לא קיימת, אין טעם לשמור
            if (!componentMounted.current && !extraState.forceUpdate) {
                console.log("⚠️ Not saving - component no longer mounted");
                return null;
            }
            
            // בדיקת תקופת אתחול לשמירה ראשונה
            const currentTime = Date.now();
            const battleInitTime = parseInt(localStorage.getItem('battleInitTime') || '0');
            const timeSinceInit = currentTime - battleInitTime;
            
            // רק בסיום האתחול, התחל לשמור מצב
            if (timeSinceInit < 3000 && !extraState.forceUpdate && !extraState.isNewBattle) {
                console.log("⚠️ Not saving during initialization period (first 3 seconds)");
                return null;
            }
            
            // וידוא שיש מידע תקין לשמירה
            if (!yourPokemon || !oppPokemon) {
                console.log("⚠️ Not saving - missing Pokemon data");
                return null;
            }
            
            // בנית מבנה הנתונים לשמירה - כולל battlePokemons עם HP מעודכן
            const battleState = {
                yourPokemon,
                oppPokemon,
                battlePokemons, // שמירת כל הפוקימונים עם HP מעודכן
                isPlayerTurn: extraState.isPlayerTurn !== undefined ? extraState.isPlayerTurn : isPlayerTurn, // שמירת מצב התור - חשוב מאוד!
                battleActive,
                attackList,
                winLose,
                isMapBattle,
                lastActionTime: currentTime,
                battleInitialized: true,
                battleStartTime: battleStartTime || extraState.battleStartTime, // שמירת זמן התחלת הקרב
                battleTimer: battleTimer || extraState.battleTimer, // שמירת הטיימר
                ...extraState
            };
            
            // שמירה ב-localStorage
            localStorage.setItem('activeBattle', JSON.stringify(battleState));
            
            // לוג מצומצם כדי לא להציף את הקונסול
            console.log("💾 Battle state saved - Player turn:", isPlayerTurn, 
                      "Player HP:", yourPokemon.leven + "/" + yourPokemon.levenmax,
                      "Enemy HP:", oppPokemon.leven + "/" + oppPokemon.levenmax);
            
            return battleState;
        } catch (error) {
            console.error("❌ Error saving battle state:", error);
            return null;
        }
    };

    // פונקציה ללוגים
    const logToFile = async (message, data = {}) => {
        try {
            const logData = {
                timestamp: new Date().toISOString(),
                message: message,
                pathname: window.location.pathname,
                battleState: {
                    battleActive,
                    winLose,
                    isMapBattle,
                    playerPokemonId: yourPokemon?.id,
                    enemyLevel: oppPokemon?.level,
                    playerHP: `${yourPokemon?.leven}/${yourPokemon?.levenmax}`,
                    enemyHP: `${oppPokemon?.leven}/${oppPokemon?.levenmax}`
                },
                ...data
            };
            
            // Send to server for logging
            await axiosInstance.post('/api/api/log-client.php', {
                message: JSON.stringify(logData),
                pathname: window.location.pathname,
                type: 'battle'
            }).catch(() => {}); // Ignore errors in logging
            
            console.log(`📝 [LOG] ${message}`, data);
        } catch (error) {
            // Silent fail for logging
        }
    };
    
    // פונקציה לשליחת תוצאת הקרב לשרת
    const handleBattleFinish = async (result) => {
        // Prevent duplicate calls
        if (battleFinishCalled.current) {
            console.log("⚠️ Battle finish already called, skipping duplicate call");
            await logToFile("Battle finish already called, skipping duplicate", { result });
            return;
        }
        
        battleFinishCalled.current = true;
        
        try {
            // Save current Pokemon's HP to battlePokemons before sending to server
            if (yourPokemon && yourPokemon.id) {
                setBattlePokemons(prev => prev.map(p => 
                    p.id === yourPokemon.id ? { ...p, leven: yourPokemon.leven } : p
                ));
            }
            
            // Get the latest battlePokemons state (with current HP saved)
            // Use a small delay to ensure state is updated, or use the current battlePokemons directly
            const pokemonsToUpdate = battlePokemons.map(p => {
                // If this is the current Pokemon, use its current HP
                if (p.id === yourPokemon?.id) {
                    return {
                        id: p.id,
                        hp: yourPokemon.leven || p.leven || 0
                    };
                }
                return {
                    id: p.id,
                    hp: p.leven || 0
                };
            });
            
            console.log("📤 Preparing battle finish payload:", {
                result,
                pokemon_id: yourPokemon?.id,
                pokemon_hp: yourPokemon?.leven,
                all_pokemons_count: pokemonsToUpdate.length,
                all_pokemons: pokemonsToUpdate
            });
            
            // Check if this is a trainer battle
            if (isTrainerBattle && trainerBattleId) {
                // Finish trainer battle
                const urlParams = new URLSearchParams(window.location.search);
                const mapPointId = urlParams.get('map_point_id');
                
                const trainerPayload = {
                    battle_id: parseInt(trainerBattleId),
                    result: result === 'win' ? 'win' : 'loss',
                    all_pokemons: pokemonsToUpdate
                };
                
                console.log("📤 Sending trainer battle finish result to server:", result);
                await logToFile("Sending trainer battle finish to server", { 
                    result, 
                    payload: trainerPayload,
                    token: localStorage.getItem('token') ? 'EXISTS' : 'MISSING'
                });
                
                const finishResponse = await axiosInstance.post(API_ENDPOINTS.FINISH_TRAINER_BATTLE, trainerPayload);
                
                if (finishResponse.data && finishResponse.data.success) {
                    console.log("✅ Trainer battle finish processed successfully:", finishResponse.data);
                    
                    if (result === 'win' && finishResponse.data.rewards) {
                        const rewards = finishResponse.data.rewards;
                        let rewardMessages = [];
                        
                        rewards.forEach(reward => {
                            if (reward.type === 'silver') {
                                rewardMessages.push(`${reward.amount} Silver`);
                            } else if (reward.type === 'experience') {
                                rewardMessages.push(`Double XP: ${reward.amount}`);
                            } else if (reward.type === 'item') {
                                rewardMessages.push(`${reward.quantity}x ${reward.description}`);
                            } else if (reward.type === 'gold') {
                                rewardMessages.push(`${reward.amount} Gold`);
                            } else if (reward.type === 'pokemon') {
                                rewardMessages.push(reward.description);
                            }
                        });
                        
                        toast.success(t('Victory! Rewards: {{rewards}}', { 
                            rewards: rewardMessages.join(', ') 
                        }));
                    }
                }
                
                return finishResponse;
            }
            
            // Regular map battle
            // Get point_id and gebied from URL for mission tracking
            const urlParams = new URLSearchParams(window.location.search);
            const pointId = urlParams.get('point_id');
            const gebiedParam = urlParams.get('gebied');
            
            const payload = {
                result: result,
                pokemon_id: yourPokemon?.id || 0,  // Only this one gets exp
                enemy_level: oppPokemon?.level || 5,
                enemy_wild_id: oppPokemon?.wild_id || 0,  // Enemy Pokemon wild_id for pokedex
                pokemon_hp: yourPokemon?.leven || 0,  // Current Pokemon HP
                all_pokemons: pokemonsToUpdate,  // All Pokemon that participated (for HP updates)
                point_id: pointId ? parseInt(pointId) : 0,  // Map point ID for mission tracking
                gebied: gebiedParam || ''  // Area name for mission tracking
            };
            
            console.log("📤 Sending battle finish result to server:", result);
            await logToFile("Sending battle finish to server", { 
                result, 
                payload,
                token: localStorage.getItem('token') ? 'EXISTS' : 'MISSING'
            });
            
            const finishResponse = await axiosInstance.post(API_ENDPOINTS.FINISH_MAP_BATTLE, payload);
            
            if (finishResponse.data && finishResponse.data.success) {
                console.log("✅ Battle finish processed successfully:", finishResponse.data);
                await logToFile("Battle finish success", { 
                    result, 
                    response: finishResponse.data 
                });
                
                if (result === 'win' && finishResponse.data.reward) {
                    const reward = finishResponse.data.reward;
                    if (reward.leveled_up) {
                        toast.success(t('Victory! You earned {{money}} silver and your Pokemon leveled up to {{level}}!', { 
                            money: reward.money, 
                            level: reward.new_level 
                        }));
                    } else {
                        toast.success(t('Victory! You earned {{money}} silver!', { 
                            money: reward.money 
                        }));
                    }
                    
                    // Check for evolution
                    if (finishResponse.data.evolution && finishResponse.data.evolution.length > 0) {
                        const firstEvolution = finishResponse.data.evolution[0];
                        setEvolutionData(firstEvolution);
                        setShowEvolutionModal(true);
                        setShowEvolutionAnimation(true);
                    }
                    
                    // Check for pending attacks to learn
                    console.log('[LEARN ATTACK] Response data:', finishResponse.data);
                    console.log('[LEARN ATTACK] pending_attacks:', finishResponse.data.pending_attacks);
                    
                    if (finishResponse.data.pending_attacks && finishResponse.data.pending_attacks.length > 0) {
                        const firstPendingAttack = finishResponse.data.pending_attacks[0];
                        console.log('[LEARN ATTACK] Setting pending attack data:', firstPendingAttack);
                        // Save to localStorage to persist across component remounts
                        localStorage.setItem('pendingAttackData', JSON.stringify(firstPendingAttack));
                        setPendingAttackData(firstPendingAttack);
                        setShowLearnAttackModal(true);
                    } else {
                        console.log('[LEARN ATTACK] No pending attacks in response');
                        // Clear any stale data
                        localStorage.removeItem('pendingAttackData');
                    }
                    
                    // Refresh user profile to get updated stats
                    if (finishResponse.data.user) {
                        // Update user data in Redux if needed
                        dispatch(getProfile());
                    }
                    
                    // Refresh Pokemon data to get updated exp, level, and HP - חשוב מאוד!
                    if (isMapBattle && yourPokemon?.id) {
                        // Small delay to ensure server has updated the data
                        setTimeout(() => {
                            console.log("🔄 Refreshing Pokemon data after battle finish");
                            dispatch(getPlayerPokemons()).then((result) => {
                                if (result.payload && Array.isArray(result.payload) && result.payload.length > 0) {
                                    const updatedPokemon = result.payload.find(p => p.id === yourPokemon?.id);
                                    if (updatedPokemon) {
                                        // Ensure exp fields are properly parsed
                                        const pokemonWithExp = {
                                            ...updatedPokemon,
                                            exp: parseInt(updatedPokemon.exp || updatedPokemon['exp'] || 0),
                                            expnodig: parseInt(updatedPokemon.expnodig || updatedPokemon['expnodig'] || 100)
                                        };
                                        
                                        console.log("🔄 Updating Pokemon with new data:", {
                                            id: pokemonWithExp.id,
                                            exp: pokemonWithExp.exp,
                                            expnodig: pokemonWithExp.expnodig,
                                            level: pokemonWithExp.level,
                                            expPercentage: pokemonWithExp.expnodig > 0 ? (pokemonWithExp.exp / pokemonWithExp.expnodig * 100).toFixed(2) : 0
                                        });
                                        
                                        setYourPokemon(pokemonWithExp);
                                        // Update in battle pokemons list too
                                        setBattlePokemons(prev => prev.map(p => 
                                            p.id === pokemonWithExp.id ? pokemonWithExp : p
                                        ));
                                    } else {
                                        console.warn("⚠️ Updated Pokemon not found in response. Looking for ID:", yourPokemon?.id);
                                        console.warn("⚠️ Available Pokemon IDs:", result.payload.map(p => p.id));
                                    }
                                } else {
                                    console.warn("⚠️ No Pokemon data in response. Payload:", result.payload);
                                }
                            }).catch(err => {
                                console.error("❌ Error refreshing pokemon data:", err);
                            });
                        }, 1000); // Wait 1 second for server to update
                    }
                } else if (result === 'lose' && finishResponse.data.penalty) {
                    toast.warning(t('Defeat! You lost {{money}} silver.', { 
                        money: finishResponse.data.penalty.money_lost 
                    }));
                    
                    // Refresh Pokemon data after loss to get updated HP - חשוב מאוד!
                    setTimeout(() => {
                        console.log("🔄 Refreshing Pokemon data after battle loss");
                        dispatch(getPlayerPokemons());
                    }, 500);
                }
            } else {
                await logToFile("Battle finish - invalid response", { 
                    result, 
                    response: finishResponse.data 
                });
            }
        } catch (error) {
            console.error("❌ Error finishing battle:", error);
            await logToFile("Battle finish error", { 
                result,
                error: error?.message,
                errorResponse: error?.response?.data,
                status: error?.response?.status,
                headers: error?.response?.headers
            });
            toast.error(error?.response?.data?.message || t('Failed to process battle result.'));
        }
    };
    
    // פונקציה לבדיקה אם מותר לצאת מהקרב
    const canExitBattle = () => {
        // אם הקומפוננטה עוד לא נטענה לגמרי, אל תאפשר יציאה
        if (!componentMounted.current) {
            console.log("Component not fully mounted, preventing exit");
            return false;
        }
        
        // אם הקרב לא פעיל, מותר לצאת
        if (!battleActive) {
            return true;
        }
        
        // שמירת מצב עדכני של הקרב לפני בדיקת יכולת יציאה
        updateBattleState({ forceUpdate: true });
        
        // היתרים ספציפיים ליציאה:
        // 1. קרב הסתיים (ניצחון/הפסד)
        // 2. יציאה מכוונת דרך כפתור
        // 3. מצב ייחודי אחר שאושר ע"י המערכת
        const canExit = !!winLose || manualExit.current || userAllowedToExit;
        
        console.log("Exit check: can exit =", canExit, 
                   "winLose =", winLose || "none", 
                   "manualExit =", manualExit.current, 
                   "userAllowed =", userAllowedToExit);
        
        return canExit;
    };

    // עדכון פונקצית הניווט למפה עם הגנות נוספות
    const tryNavigateToMap = () => {
        console.log("🗺️ Attempting to navigate to map from battle");
        
        // אם הקומפוננטה לא מורכבת עדיין, נמנע ניווט
        if (!componentMounted.current) {
            console.log("⛔ Component not fully mounted, preventing navigation");
            return;
        }
        
        // בדיקה אם מותר לצאת מהקרב
        const exitAllowed = canExitBattle();
        
        if (exitAllowed) {
            console.log("✅ Exit allowed - navigating to map");
            
            // סימון יציאה מרצון לפני שינוי מצב
            manualExit.current = true;
            setUserAllowedToExit(true);
            
            // אם הקרב הסתיים, אפשר לצאת
            if (winLose) {
                console.log("🏁 Battle ended with result:", winLose);
            } else {
                console.log("🚪 Manual exit approved");
            }
            
            // ניקוי המידע ב-localStorage
            localStorage.removeItem('activeBattle');
            localStorage.removeItem('battleNavigationLocked');
            localStorage.removeItem('battleInitTime');
            localStorage.removeItem('battleInstanceTime');
            
            // עדכון מצב
            setBattleActive(false);
            
            // השהייה קלה לפני הניווט להבטחת שמירת השינויים
            setTimeout(() => {
                if (componentMounted.current) {
                    console.log("🚀 Navigating to map now");
                    navigate('/map');
                }
            }, 200);
        } else {
            console.log("⛔ Exit not allowed - battle is still active");
            
            // רק אם הקרב באמת פעיל, הצג הודעה
            if (battleActive && !winLose) {
                toast.warning(t('Cannot exit an active battle! Win or lose to finish.'));
            }
            
            // עדכון זמן פעולה אחרונה
            setLastActionTime(Date.now());
        }
    };
    
    // עדכון ושיפור פונקצית ה-tryEscape
    const tryEscape = () => {
        // מניעת ניסיון בריחה בזמן התקפה או אם הקרב לא פעיל
        if (oppAttacking || attacking || !battleActive || !componentMounted.current) {
            return;
        }
        
        // עדכון זמן הפעולה האחרונה
        setLastActionTime(Date.now());
        
        // אם הקרב כבר הסתיים, מאפשרים יציאה מידית
        if (winLose) {
            manualExit.current = true;
            setUserAllowedToExit(true);
            
            // השהייה קצרה לפני הניווט כדי לוודא שכל השינויים נשמרו
            setTimeout(() => {
                if (componentMounted.current && isMapBattle) {
                    navigate('/map');
                }
            }, 100);
            return;
        }
        
        // סיכוי בריחה מהקרב - 70%
        const escapeChance = Math.random();
        console.log(`🎲 Escape attempt - chance: ${escapeChance.toFixed(2)} (need < 0.7)`);
        
        if (escapeChance < 0.7) {
            // הצלחה בבריחה
            console.log("✅ Escape successful!");
            toast.success(t('Successfully escaped from battle!'));
            manualExit.current = true; // סימון שהיציאה היא מרצון
            setUserAllowedToExit(true);
            
            if (isMapBattle) {
                // מחיקת הקרב מה-localStorage לפני יציאה
                localStorage.removeItem('activeBattle');
                localStorage.removeItem('battleInitTime');
                setBattleActive(false);
                
                // השהייה קצרה לפני הניווט כדי לוודא שכל השינויים נשמרו
                setTimeout(() => {
                    if (componentMounted.current) {
                        navigate('/map');
                    }
                }, 100);
            } else {
                // בקרב דו-קרב, סימון כהפסד
                setWinLose('lose');
            }
        } else {
            // כישלון בבריחה
            console.log("❌ Escape attempt failed");
            toast.warning(t('Escape attempt failed!'));
            
            // העברת התור לאויב
            setIsPlayerTurn(false);
            
            // התקפה נגדית
            setTimeout(() => {
                if (battleActive && componentMounted.current) {
                    console.log("⚔️ Enemy counterattack after failed escape");
                    const wildAttack = {
                        name: 'Counter Attack',
                        damage: Math.floor(Math.random() * 15) + 10,
                        type: "Normal"
                    };
                    opp_attack(wildAttack);
                } else {
                    console.log("⚠️ Battle no longer active - canceling counterattack");
                }
            }, 500);
        }
    };

    // פונקציה לקבלת נתיב תמונה של פריט
    const getItemImage = (itemName) => {
        // Replace spaces with underscores to match file names
        // Files have been renamed: "Poke ball.png" -> "Poke_ball.png"
        const normalizedName = itemName.trim();
        const fileName = normalizedName.replace(/\s+/g, '_');
        return `/images/items/${fileName}.png`;
    };

    // פונקציה לטעינת פריטים מהתיק
    const loadPokeballs = async () => {
        setLoadingPokeballs(true);
        try {
            const response = await axiosInstance.get(API_ENDPOINTS.GET_USER_ITEMS);
            if (response.data && response.data.success) {
                console.log("✅ Loaded items:", response.data);
                
                // Set pokeballs
                if (response.data.pokeballs) {
                    setPokeballs(response.data.pokeballs);
                    response.data.pokeballs.forEach(ball => {
                        const imagePath = getItemImage(ball.name);
                        console.log(`  - Ball: "${ball.name}", Image path: ${imagePath}`);
                    });
                }
                
                // Set potions
                if (response.data.potions) {
                    setPotions(response.data.potions);
                }
                
                // Set other items
                if (response.data.otherItems) {
                    setOtherItems(response.data.otherItems);
                }
                
                // Set all items (for convenience) - combine all categories
                const combined = [
                    ...(response.data.pokeballs || []),
                    ...(response.data.potions || []),
                    ...(response.data.otherItems || [])
                ];
                setAllItems(combined);
                
                console.log("📦 Combined items:", combined.length, "items");
                console.log("  - Pokeballs:", response.data.pokeballs?.length || 0);
                console.log("  - Potions:", response.data.potions?.length || 0);
                console.log("  - Other items:", response.data.otherItems?.length || 0);
            } else {
                console.warn("⚠️ No items loaded - response.data.success is false");
                setAllItems([]);
            }
        } catch (error) {
            console.error("❌ Error loading items:", error);
            setAllItems([]);
        } finally {
            setLoadingPokeballs(false);
        }
    };

    // פונקציה לשימוש בפוקדור
    const handlePokeball = async (ball) => {
        // בקרבות מאמן לא ניתן להשתמש בפוקדורים
        if (isTrainerBattle) {
            toast.error(t('Cannot catch trainer\'s Pokemon! They already have a trainer.'));
            return;
        }
        
        if (!isMapBattle || !oppPokemon?.wild_id) {
            toast.error(t('Cannot use pokeball in this battle!'));
            return;
        }

        if (oppAttacking || !isPlayerTurn || throwingBall) {
            toast.warning(t('Cannot use pokeball during opponent\'s turn!'));
            return;
        }

        // בדיקת HP של האויב - אם החיים פחות מ-5, סיכוי מצוין (90%)
        const enemyHPPercent = (oppPokemon.leven / oppPokemon.levenmax) * 100;
        const enemyHP = oppPokemon.leven;
        const playerHP = yourPokemon?.leven || 0;
        
        // חישוב סיכוי תפיסה לפי הדרישות:
        // 1. אם החיים פחות מ-5, סיכוי מצוין (90%)
        // 2. אם החיים של האויב קטנים יותר מהחיים של השחקן, סיכוי טוב יותר
        // 3. תלוי בנדירות הפוקימון (zeldzaamheid)
        // 4. תלוי בכוח הפוקדור
        
        let catchChance = 0.3; // סיכוי בסיסי
        
        // אם החיים פחות מ-5, סיכוי מצוין (90%)
        if (enemyHP < 5) {
            catchChance = 0.9;
        } else if (enemyHP < playerHP) {
            // אם החיים של האויב קטנים יותר, סיכוי טוב יותר
            catchChance = 0.6;
        } else if (enemyHPPercent < 20) {
            // אם החיים פחות מ-20%, סיכוי טוב
            catchChance = 0.5;
        } else if (enemyHPPercent < 50) {
            // אם החיים פחות מ-50%, סיכוי בינוני
            catchChance = 0.4;
        }
        
        // התאמה לפי כוח הפוקדור
        const ballPower = ball.power || 1;
        catchChance = Math.min(0.95, catchChance * (1 + (ballPower - 1) * 0.1));
        
        // Master ball, DNA ball, Cherish ball, Black ball, Santa ball, GS ball - תמיד תופסים
        const guaranteedBalls = ['Master ball', 'DNA ball', 'Cherish ball', 'Black ball', 'Santa ball', 'GS ball'];
        if (guaranteedBalls.includes(ball.name)) {
            catchChance = 1.0;
        }
        
        console.log("🎣 Using pokeball:", ball.name, "Catch chance:", (catchChance * 100).toFixed(2) + "%", "Enemy HP:", enemyHP, "Player HP:", playerHP);
        
        // התחלת אנימציית זריקת כדור
        setThrowingBall(true);
        setBallCaught(false);
        setCurrentBall(ball); // שמירת הכדור הנוכחי
        setCapturePhase('throwing'); // שלב 1: זריקה
        
        try {
            // שלב 1: כדור נזרק (2.5 שניות)
            await new Promise(resolve => setTimeout(resolve, 2500));
            
            // שלב 2: כדור פוגע - הפוקימון מתכווץ והופך ללבן (1.2 שניות)
            setCapturePhase('capturing');
            await new Promise(resolve => setTimeout(resolve, 1200));
            
            // שלב 3: כדור רועד - מנסה לתפוס (1.5 שניות)
            setCapturePhase('shaking');
            await new Promise(resolve => setTimeout(resolve, 1500));
            
            // Check catch result from server (server calculates catch chance)
            let caught = false;
            try {
                const catchResponse = await axiosInstance.post(API_ENDPOINTS.USE_POKEBALL_MAP_BATTLE, {
                    item: ball.name,
                    wild_id: oppPokemon.wild_id,
                    level: oppPokemon.level || 5,
                    enemy_hp: oppPokemon.leven,
                    enemy_max_hp: oppPokemon.levenmax,
                    player_hp: yourPokemon?.leven || 0,
                    enemy_level: oppPokemon.level || 5,
                    caught: false // Will be calculated on server
                });
                
                if (catchResponse.data && catchResponse.data.success) {
                    caught = catchResponse.data.caught || false;
                    console.log(`🎣 Server catch result: Ball: ${ball.name}, Result: ${caught ? 'SUCCESS' : 'FAILED'}`);
                } else {
                    console.error("❌ API returned success=false:", catchResponse.data);
                    // Fallback to client-side calculation if server fails
                    caught = Math.random() < catchChance;
                    console.log(`🎣 Fallback catch calculation: Ball: ${ball.name}, Chance: ${(catchChance * 100).toFixed(2)}%, Result: ${caught ? 'SUCCESS' : 'FAILED'}`);
                }
            } catch (catchError) {
                console.error("❌ Error checking catch result:", catchError);
                // Fallback to client-side calculation if server fails
                caught = Math.random() < catchChance;
                console.log(`🎣 Fallback catch calculation: Ball: ${ball.name}, Chance: ${(catchChance * 100).toFixed(2)}%, Result: ${caught ? 'SUCCESS' : 'FAILED'}`);
            }
            
            if (caught) {
                // שלב 4א: תפיסה מוצלחת!
                setCapturePhase('caught');
                setBallCaught(true);
                
                // מחכה לאנימציית ההצלחה (1.5 שניות)
                await new Promise(resolve => setTimeout(resolve, 1500));
                
                // Pokemon was already caught in previous API call, just verify
                console.log("✅ Pokemon caught successfully!");
                
                // הקרב מסתיים בניצחון - פופאפ כמו "You Win"
                setWinLose('win');
                setBattleActive(false);
                
                // עדכון רשימת הפוקימונים - גם team וגם box
                setTimeout(() => {
                    dispatch(getPlayerPokemons());
                    // גם לטעון את כל הפוקימונים (כולל box) כדי שהפוקימון החדש יופיע
                    // זה יקרה אוטומטית כש-Pokebag יטען מחדש
                }, 500);
                
                // ניקוי localStorage
                localStorage.removeItem('activeBattle');
                localStorage.removeItem('battleNavigationLocked');
                localStorage.removeItem('battleInitTime');
                localStorage.removeItem('battleInstanceTime');
                
                // רענון רשימת הפוקדורים
                loadPokeballs();
                
                // איפוס state
                setCurrentBall(null);
                setCapturePhase(null);
                setThrowingBall(false);
                
                // חזרה ל-MAP אחרי 3 שניות
                setTimeout(() => {
                    navigate('/home');
                }, 3000);
            } else {
                // שלב 4ב: הפוקימון בורח! כדור מתפוצץ והפוקימון חוזר
                setCapturePhase('escaping');
                setBallCaught(false);
                
                // מחכה לאנימציית הבריחה (1.5 שניות)
                await new Promise(resolve => setTimeout(resolve, 1500));
                
                // Pokeball amount was already decreased in previous API call
                console.log("✅ Pokeball used (not caught) - amount already decreased");
                
                setThrowingBall(false);
                setCurrentBall(null);
                setCapturePhase(null);
                
                toast.warning(t('{{name}} broke free!', { name: oppPokemon.naam }));
                // התור עובר לאויב
                setIsPlayerTurn(false);
                setLastActionTime(Date.now());
                
                // שמירת מצב מעודכן
                setTimeout(() => {
                    updateBattleState({ forceUpdate: true, isPlayerTurn: false });
                }, 100);
                
                // רענון רשימת הפוקדורים (חשוב לעדכן את הכמויות)
                loadPokeballs();
            }
        } catch (error) {
            console.error("❌ Error using pokeball:", error);
            setThrowingBall(false);
            setBallCaught(false);
            setCapturePhase(null);
            toast.error(t('Failed to use pokeball!'));
        }
    };

    // פונקציה לבחירת סוג פעולה
    const selectedType = (type) => {
        // חסימת פעולות כשהאויב תוקף או כשזה לא התור של השחקן
        if (attacking || oppAttacking || !isPlayerTurn) {
            if (oppAttacking || !isPlayerTurn) {
                toast.warning(t('Cannot perform actions during opponent\'s turn!'));
            }
            return; // אין לשנות סוג פעולה באמצע התקפה או בתור של האויב
        }
        
        setType(type);
        setLastActionTime(Date.now());
        
        // אם נבחרה אופציית "Mochila" (תיק), טען פריטים
        if (type === 'Mochila') {
            loadPokeballs();
        }
        
        // אם נבחרה אופציית "Fugir" (בריחה), ננסה לברוח
        if (type === 'Fugir') {
            tryEscape();
        }
    }

    // פונקציה לניסיון ניווט עם בדיקה אם מותר לצאת מהקרב
    // הגנה 2: אי אפשר לצאת מהעמוד עד שהקרב מסתיים
    const safeNavigate = (path) => {
        console.log("🔍 Safe navigation attempt to:", path);
        
        // בדיקה ראשונית - אם הקרב פעיל ולא הסתיים, חסום ניווט
        if (battleActive && !winLose) {
            console.log("⛔ Navigation blocked - active battle");
            toast.warning(t('Cannot exit an active battle! Win or lose to finish.'));
            return;
        }
        
        // אם מותר לצאת מהקרב, ניווט רגיל
        if (canExitBattle()) {
            console.log("✅ Navigation allowed - battle can be exited");
            navigate(path);
        } else {
            console.log("⛔ Navigation blocked - active battle");
            toast.warning(t('Cannot exit an active battle! Win or lose to finish.'));
        }
    };

    // בדיקת זיהוי רימאונט של קרב פעיל
    useEffect(() => {
        // בדיקה אם יש קרב פעיל כרגע
        console.log("🔍 Battle component mounted. Current active battle:", 
                   activeBattleInstance, "this instance:", battleInstanceId.current);
                   
        if (activeBattleInstance && activeBattleInstance !== battleInstanceId.current) {
            console.log("⚠️ Another battle instance is already active:", activeBattleInstance);
            console.log("⚠️ This is likely an unwanted remount during active battle!");
            
            // זיהוי אם הרימאונט קרה תוך פחות מ-3 שניות מהקרב הקיים
            const lastInit = parseInt(localStorage.getItem('battleInstanceTime') || '0');
            const currentTime = Date.now();
            const timeSinceLastInit = currentTime - lastInit;
            
            if (timeSinceLastInit < 3000) {
                console.log("⚠️ Very rapid remount detected (< 3s). Special handling activated.");
                
                // מחיקת הקרב הישן ויצירת קרב חדש מבוסס על הנתונים בשמירה
                activeBattleInstance = battleInstanceId.current;
                localStorage.setItem('battleInstanceTime', currentTime.toString());
                
                // מיד טען את הנתונים מהשמירה האחרונה אם קיימת
                const savedState = localStorage.getItem('activeBattle');
                if (savedState) {
                    try {
                        const parsedState = JSON.parse(savedState);
                        setTimeout(() => {
                            if (componentMounted.current) {
                                console.log("♻️ Restoring battle state after rapid remount");
                                setYourPokemon(parsedState.yourPokemon);
                                setOppPokemon(parsedState.oppPokemon);
                                setAttackList(parsedState.attackList || attackList);
                                setIsPlayerTurn(parsedState.isPlayerTurn);
                                // Restore battlePokemons if available - filter to only team Pokemon
                                if (parsedState.battlePokemons && Array.isArray(parsedState.battlePokemons)) {
                                    const teamPokemons = parsedState.battlePokemons.filter(p => p.opzak === 'ja');
                                    setBattlePokemons(teamPokemons);
                                    console.log("🔍 Restored battlePokemons from parsedState - filtered to team only:", teamPokemons.length, "out of", parsedState.battlePokemons.length);
                                }
                                setBattleActive(true);
                                battleInitialized.current = true;
                            }
                        }, 100);
                    } catch (error) {
                        console.error("❌ Error restoring state after rapid remount:", error);
                    }
                }
            } else {
                console.log("ℹ️ Normal remount (> 3s). Treating as new battle instance.");
                activeBattleInstance = battleInstanceId.current;
                localStorage.setItem('battleInstanceTime', currentTime.toString());
            }
        } else {
            // רישום הקרב הנוכחי כפעיל
            activeBattleInstance = battleInstanceId.current;
            localStorage.setItem('battleInstanceTime', Date.now().toString());
            console.log("✅ Setting this as active battle instance:", battleInstanceId.current);
        }
        
        // ניקוי כאשר הקומפוננטה מפורקת
        return () => {
            if (activeBattleInstance === battleInstanceId.current) {
                console.log("🔄 Clearing active battle instance:", battleInstanceId.current);
                activeBattleInstance = null;
            } else {
                console.log("ℹ️ Not clearing battle instance - this is not the active one");
            }
        };
    }, []);

    // הגדרת תזמון שיפתח את אבטחת הניווט רק בקרב מסתיים
    useEffect(() => {
        // אל תשחרר את הנעילה אלא אם כן הקרב הסתיים
        if (winLose) {
            console.log("🏁 Battle ended with", winLose, "- releasing navigation lock");
            setNavigationLocked(false);
        }
    }, [winLose]);

    return (
        <>
            <GoldSiverHeader previous='/home' title='Battle'>
                <section className="ar_battle_area_section position-relative">
                    {
                        winLose == 'win' && 
                        <div className='win-class' dir={isRTL ? 'rtl' : 'ltr'}>
                            <section className="modal_area">
                                <div className="modal_content">
                                    <div className="modal_button">
                                        <a className="modal_btn" href="#" onClick={(e) => { e.preventDefault(); }}>
                                            <img src="/images/modal/successfully-message.png" alt="" />
                                            <p>{ballCaught ? t('Successful catch') : t('You Win')} !!</p>
                                        </a>
                                        {isMapBattle && (
                                            <button 
                                                className="battle-result-button"
                                                onClick={() => {
                                                    localStorage.removeItem('activeBattle');
                                                    localStorage.removeItem('battleNavigationLocked');
                                                    localStorage.removeItem('battleInitTime');
                                                    localStorage.removeItem('battleInstanceTime');
                                                    navigate('/map');
                                                }}
                                            >
                                                {t('Return to Home')}
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </section>
                        </div>
                    }
                    {
                        winLose == 'lose' && 
                        <div className='lose-class' dir={isRTL ? 'rtl' : 'ltr'}>
                            <section className="modal_area">
                                <div className="modal_content">
                                    <div className="modal_button">
                                        <a className="modal_btn" href="#" onClick={(e) => { e.preventDefault(); }}>
                                            <img src="/images/modal/successfully-message.png" alt="" />
                                            <p>{t('You Lose')} !!</p>
                                        </a>
                                        {isMapBattle && (
                                            <button 
                                                className="battle-result-button"
                                                onClick={() => {
                                                    localStorage.removeItem('activeBattle');
                                                    localStorage.removeItem('battleNavigationLocked');
                                                    localStorage.removeItem('battleInitTime');
                                                    localStorage.removeItem('battleInstanceTime');
                                                    // בדיקה אם כל הפוקימונים נהרגו
                                                    const allFainted = battlePokemons.every(p => p.leven <= 0);
                                                    if (allFainted) {
                                                        navigate('/hospital');
                                                    } else {
                                                        navigate('/home');
                                                    }
                                                }}
                                            >
                                                {battlePokemons.every(p => p.leven <= 0) ? t('Go to Hospital') : t('Return to Home')}
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </section>
                        </div>
                    }
                    {oppAttacking && <div className='opp-attacking'>{t('Opponent attacking')}...</div>}
                    {!isPlayerTurn && !oppAttacking && battleActive && !winLose && 
                        <div className='opp-turn'>{t("Opponent's turn")}...</div>}
                    {isPlayerTurn && !attacking && battleActive && !winLose && 
                        <div className='player-turn'>{t("Your turn - choose an action")}!</div>}
                    <div className="p-3 container-md">
                        <div className="row ">
                            <div className="col-md-12">
                                <div className={`ar_batte_area ${screenShake ? 'screen-shake' : ''}`}>
                                    {/* מסך טעינה עם ספינר פוקדור */}
                                    {isLoading && (
                                        <div className="battle-loading-overlay">
                                            <div className="battle-loading-spinner">
                                                <div className="pokeball-center"></div>
                                                <div className="pokeball-line"></div>
                                            </div>
                                            <div className="battle-loading-text">{t('Finding wild Pokemon')}...</div>
                                        </div>
                                    )}
                                    {/* Trainer battle countdown */}
                                    {!isLoading && trainerBattleCountdown !== null && trainerBattleCountdown > 0 && !battleActive && (
                                        <div className="trainer-battle-countdown-overlay" style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            background: 'rgba(0, 0, 0, 0.8)',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            zIndex: 1000
                                        }}>
                                            {trainerImage && (
                                                <img 
                                                    src={
                                                        trainerImage.startsWith('http') 
                                                            ? trainerImage 
                                                            : trainerImage.startsWith('/api/assets/images/attack/')
                                                            ? trainerImage
                                                            : `/api/assets/images/attack/${trainerImage}`
                                                    }
                                                    alt={trainerName}
                                                    style={{
                                                        width: '150px',
                                                        height: '150px',
                                                        borderRadius: '50%',
                                                        border: '5px solid #ffc323',
                                                        marginBottom: '20px'
                                                    }}
                                                    onError={(e) => {
                                                        e.target.style.display = 'none';
                                                    }}
                                                />
                                            )}
                                            {trainerName && (
                                                <h2 style={{ color: '#ffc323', fontSize: '32px', marginBottom: '20px', textShadow: '2px 2px 4px rgba(0,0,0,0.8)' }}>
                                                    {trainerName}
                                                </h2>
                                            )}
                                            <div style={{ 
                                                fontSize: '72px', 
                                                color: '#fff', 
                                                fontWeight: 'bold',
                                                textShadow: '4px 4px 8px rgba(0,0,0,0.9)',
                                                animation: trainerBattleCountdown <= 3 ? 'pulse 0.5s infinite' : 'none'
                                            }}>
                                                {trainerBattleCountdown}
                                            </div>
                                            <div style={{ color: '#fff', fontSize: '24px', marginTop: '20px' }}>
                                                {t('Battle starting in')}...
                                            </div>
                                        </div>
                                    )}
                                    {/* אנימציית זריקת כדור */}
                                    {throwingBall && currentBall && (
                                        <div className="pokeball-throw-animation">
                                            <div className={`pokeball-sprite ${
                                                capturePhase === 'throwing' ? 'throwing' :
                                                capturePhase === 'capturing' ? 'capturing' :
                                                capturePhase === 'shaking' ? 'shaking' :
                                                capturePhase === 'caught' ? 'catch-success' :
                                                capturePhase === 'escaping' ? 'exploding' : ''
                                            }`}>
                                                <img src={getItemImage(currentBall.name)} 
                                                     alt="Pokeball" 
                                                     onError={(e) => {
                                                         e.target.onerror = null;
                                                         e.target.src = getItemImage('Poke ball');
                                                     }}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    <div className={`your-pokemon ${attacking ? 'attacking' : oppAttacking ? 'hit' : ''}`}>
                                        {isLoading ? (
                                            <div className="pokemon-loading-placeholder">
                                                <div className="pokemon-spinner"></div>
                                            </div>
                                        ) : (
                                        <img src={yourPokemon?.wild_id ? `/images/pokemon/back/${yourPokemon.wild_id}.gif` : '/images/battle/default_pokemon_back.png'} alt="" 
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = '/images/battle/default_pokemon_back.png';
                                            }}
                                        />
                                        )}
                                        {oppAttacking && currentAttack?.damage !== undefined && currentAttack?.damage > 0 && (
                                            <h1 style={{ fontWeight: 'bolder' }} className='text-danger attack-damage'>-{currentAttack.damage}</h1>
                                        )}
                                    </div>
                                    <div className={`opp-pokemon ${oppAttacking ? 'attacking' : attacking ? 'hit' : ''} ${
                                        capturePhase === 'capturing' ? 'being-captured' :
                                        capturePhase === 'shaking' || capturePhase === 'caught' ? 'sucked-into-ball' :
                                        capturePhase === 'escaping' ? 'escaping' : ''
                                    } ${pokemonSwitching === 'fainting' ? 'fainting' : ''} ${pokemonSwitching === 'appearing' ? 'appearing' : ''}`}>
                                        {capturePhase === 'shaking' || capturePhase === 'caught' ? (
                                            // הפוקימון נבלע לכדור - לא מציגים אותו
                                            null
                                        ) : isLoading ? (
                                            <div className="pokemon-loading-placeholder">
                                                <div className="pokemon-spinner"></div>
                                            </div>
                                        ) : (
                                            <>
                                                <img src={oppPokemon?.wild_id ? `/images/pokemon/${oppPokemon.wild_id}.gif` : '/images/battle/default_pokemon.png'} alt="" 
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = '/images/battle/default_pokemon.png';
                                                    }}
                                                />
                                                {attacking && currentAttack?.damage !== undefined && currentAttack?.damage > 0 && (
                                                    <h1 style={{ fontWeight: 'bolder' }} className='text-danger attack-damage'>-{currentAttack.damage}</h1>
                                                )}
                                            </>
                                        )}
                                    </div>
                                    <div className="ar_battle_area_top">
                                        {/* הגנה 3: טיימר הקרב - 3 דקות - באמצע בחלק העליון */}
                                        {battleActive && !winLose && battleStartTime && (
                                            <div className='battle-timer' style={{
                                                position: 'absolute',
                                                top: '10px',
                                                left: '50%',
                                                transform: 'translateX(-50%)',
                                                color: '#ffc323',
                                                fontSize: '35px',
                                                fontWeight: 700,
                                                zIndex: 1000,
                                                textAlign: 'center'
                                            }}>
                                                {Math.floor(battleTimer / 60)}:{(battleTimer % 60).toString().padStart(2, '0')}
                                            </div>
                                        )}
                                        <div className="ar_battleTop_left">

                                            <div className="ar_battle_left_hp_area">
                                                <div className="ar_battle_left_hp_text">
                                                    <p>{yourPokemon?.naam}</p>
                                                    <p>Lv <span>{yourPokemon?.level}</span></p>
                                                </div>
                                                <img src="/images/battle/hp-bar-empty.png" alt="images" />
                                                <div className='position-relative' style={{ 
                                                  height: '25px', 
                                                  width: `${Math.max(0, Math.min(100, (yourPokemon?.leven || 0) * 100 / (yourPokemon?.levenmax || 100)))}%`, 
                                                  top: "-35px", 
                                                  backgroundImage: 'url(/images/battle/hpRead.png)' 
                                                }}>
                                                </div>
                                                <img src="/images/battle/exp-bar-empty.png" alt="images" />
                                                <div className='position-relative' style={{ 
                                                  transition: 'width 1s ease-in-out', 
                                                  height: '12px', 
                                                  width: `${(() => {
                                                    // Calculate exp percentage
                                                    if (!yourPokemon) {
                                                        return 0;
                                                    }
                                                    
                                                    // Try different field names that might be used
                                                    const currentExp = parseInt(yourPokemon.exp || yourPokemon['exp'] || 0);
                                                    const neededExp = parseInt(yourPokemon.expnodig || yourPokemon['expnodig'] || yourPokemon.exp_needed || 100);
                                                    
                                                    // Debug log (only once per render to avoid spam)
                                                    if (Math.random() < 0.01) { // 1% chance to log
                                                        console.log("📊 Exp bar calculation:", {
                                                            currentExp,
                                                            neededExp,
                                                            pokemonId: yourPokemon.id,
                                                            level: yourPokemon.level,
                                                            allFields: Object.keys(yourPokemon).filter(k => k.includes('exp'))
                                                        });
                                                    }
                                                    
                                                    // If expnodig is the total needed for next level, calculate percentage
                                                    // Formula: (current_exp / exp_needed) * 100
                                                    if (neededExp > 0 && currentExp >= 0) {
                                                        const percentage = Math.min(100, Math.max(0, (currentExp / neededExp) * 100));
                                                        return percentage;
                                                    }
                                                    
                                                    return 0;
                                                  })()}%`, 
                                                  top: "-27px", 
                                                  backgroundImage: 'url(/images/battle/expRead.png)' 
                                                }}>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="ar_battleTop_middle">
                                            <p>Time Left: </p>
                                            <p><span>2:39</span></p>
                                        </div> */}
                                        <div className="ar_battleTop_right right">
                                            {isTrainerBattle && trainerName && (
                                                <div style={{ 
                                                    position: 'absolute',
                                                    top: '-30px',
                                                    right: '10px',
                                                    fontSize: '18px',
                                                    fontWeight: 'bold',
                                                    color: '#ffc323',
                                                    textShadow: '2px 2px 4px rgba(0,0,0,0.8)'
                                                }}>
                                                    {trainerName}
                                                    {trainerImage && (
                                                        <img 
                                                            src={
                                                        trainerImage.startsWith('http') 
                                                            ? trainerImage 
                                                            : trainerImage.startsWith('/api/assets/images/attack/')
                                                            ? trainerImage
                                                            : `/api/assets/images/attack/${trainerImage}`
                                                    }
                                                            alt={trainerName}
                                                            style={{
                                                                width: '40px',
                                                                height: '40px',
                                                                marginLeft: '10px',
                                                                borderRadius: '50%',
                                                                border: '2px solid #ffc323'
                                                            }}
                                                            onError={(e) => {
                                                                e.target.style.display = 'none';
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            )}
                                            <div className="ar_battle_left_hp_area">
                                                <div className="ar_battle_left_hp_text">
                                                    <p>{oppPokemon?.naam}</p>
                                                    <p>Lv <span>{oppPokemon?.level}</span></p>
                                                </div>
                                                <img src="/images/battle/hp-bar-empty.png" alt="images" />
                                                <div className='position-relative' style={{ 
                                                  transition: 'width 1s', 
                                                  backgroundSize: "201px", 
                                                  height: '17px', 
                                                  width: `${Math.max(0, Math.min(100, (oppPokemon?.leven || 0) * 100 / (oppPokemon?.levenmax || 100)))}%`, 
                                                  top: "-27px", 
                                                  backgroundImage: 'url(/images/battle/hpRead.png)' 
                                                }}>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="ar_battle_area_bottom">
                                        <div className="ar_battle_bottom_run" onClick={tryEscape} style={{ cursor: 'pointer' }} title={t('Run')}>
                                            <a> 
                                                <img src={"/images/battle/run.png"} alt="images" />
                                            </a>
                                        </div>
                                        <div className="ar_battle_bottom_btnAct">
                                            <div className="ar_battle_btom_single" onClick={() => { selectedType('Attack') }}>
                                                <a><img src={`/images/battle/${type == 'Attack' ? 'redAt.png' : 'selAt.png'}`} alt="images" onClick={() => { selectedType('Attack') }} /></a>
                                                <p>{t('Attack')}</p>
                                            </div>
                                            <div className="ar_battle_btom_single" onClick={() => { selectedType('Pokemon') }}>
                                                <a><img src={`/images/battle/${type == 'Pokemon' ? 'redAt.png' : 'selAt.png'}`} alt="images" onClick={() => { selectedType('Pokemon') }} /></a>
                                                <p>{t('Pokemon')}</p>
                                            </div>
                                            <div className="ar_battle_btom_single" onClick={() => { selectedType('Mochila') }}>
                                                <a><img src={`/images/battle/${type == 'Mochila' ? 'redAt.png' : 'selAt.png'}`} alt="images" onClick={() => { selectedType('Mochila') }} /></a>
                                                <p>{t('Backpack')}</p>
                                            </div>
                                        </div>
                                        {type == 'Attack' && <div>
                                            <div className="ar_battle_bottom_bottm">
                                                {attackList.length === 0 && (
                                                    <div className="text-center text-white p-3">
                                                        <p>{t('No attacks available')}</p>
                                                </div>
                                                )}
                                                {attackList.map((item, index) => {
                                                    const isDisabled = !yourPokemon || yourPokemon.leven <= 0 || oppAttacking || !isPlayerTurn;
                                                    return <div 
                                                        key={index} 
                                                        className={`ar_battle_single_bottom ${isDisabled ? 'opacity-50' : ''}`} 
                                                        onClick={() => {
                                                            if (isDisabled) {
                                                                if (oppAttacking || !isPlayerTurn) {
                                                                    toast.warning(t('Cannot attack during opponent\'s turn!'));
                                                                }
                                                                return;
                                                            }
                                                            attack(item);
                                                        }}
                                                        style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}
                                                    >
                                                        <a>
                                                            <img 
                                                                src={`/images/battle/${getAttackTypeImage(item.type)}`} 
                                                                alt="images" 
                                                                onError={(e) => {
                                                                    e.target.onerror = null;
                                                                    e.target.src = '/images/battle/Normal.png';
                                                                }}
                                                            />
                                                        </a>
                                                        <p>{item.name}</p>
                                                    </div>
                                                })}
                                            </div>
                                        </div>}
                                        {type == 'Pokemon' && <div>
                                            <div className="ar_battle_bottom_bottm">
                                                {battlePokemons
                                                    .filter((item) => 
                                                        item.id !== yourPokemon.id && 
                                                        item.leven > 0 &&
                                                        item.opzak === 'ja' // Only show team Pokemon, not box Pokemon
                                                    )
                                                    .map((item, index) => {
                                                        return <div key={index}>
                                                            <div className="ar_battle_single_bottom">
                                                                <a href="#"><img src="/images/battle/selAt.png" alt="images" /></a>
                                                                <div className='d-flex p-2 position-absolute w-100 h-100 top-0 align-items-center cursor-pointer' onClick={() => {
                                                                    // חסימת החלפת פוקימון כשהאויב תוקף
                                                                    if (oppAttacking || !isPlayerTurn) {
                                                                        toast.warning(t('Cannot switch Pokemon during opponent\'s turn!'));
                                                                        return;
                                                                    }
                                                                    
                                                                    // When switching Pokemon, save current Pokemon's HP first
                                                                    const currentPokemonId = yourPokemon.id;
                                                                    const currentPokemonHP = yourPokemon.leven;
                                                                    
                                                                    // Update battlePokemons with current Pokemon's HP before switching
                                                                    setBattlePokemons(prev => prev.map(p => 
                                                                        p.id === currentPokemonId ? { ...p, leven: currentPokemonHP } : p
                                                                    ));
                                                                    
                                                                    // Now switch to the selected Pokemon from battlePokemons (which has updated HP)
                                                                    const selectedPokemon = battlePokemons.find(p => p.id === item.id);
                                                                    if (selectedPokemon) {
                                                                        setYourPokemon(selectedPokemon);
                                                                        // עדכון ההתקפות לפי הפוקימון החדש
                                                                        updateAttacksForPokemon(selectedPokemon);
                                                                    } else {
                                                                        // Fallback to item if not found in battlePokemons
                                                                        // Only add if it's a team Pokemon (opzak = 'ja')
                                                                        if (item.opzak !== 'ja') {
                                                                            toast.warning(t('Only team Pokemon can participate in battle!'));
                                                                            return;
                                                                        }
                                                                        setYourPokemon(item);
                                                                        // עדכון ההתקפות לפי הפוקימון החדש
                                                                        updateAttacksForPokemon(item);
                                                                        setBattlePokemons(prev => {
                                                                            const exists = prev.find(p => p.id === item.id);
                                                                            if (!exists) {
                                                                                return [...prev, item];
                                                                            }
                                                                            return prev.map(p => p.id === item.id ? item : p);
                                                                        });
                                                                    }
                                                                    
                                                                    // החלפת פוקימון מבזבזת תור - התור עובר לאויב
                                                                    console.log("🔄 Pokemon switched - turn passed to opponent");
                                                                    setIsPlayerTurn(false);
                                                                    setLastActionTime(Date.now());
                                                                    
                                                                    // שמירת מצב מעודכן עם העברת התור לאויב
                                                                    setTimeout(() => {
                                                                        updateBattleState({ forceUpdate: true, isPlayerTurn: false });
                                                                    }, 100);
                                                                    
                                                                    // Close Pokemon selection menu
                                                                    setType('Attack');
                                                                }}>
                                                                    <div>
                                                                        <img src={`/images/pokemon/icon/${item.wild_id}.gif`} alt="" />
                                                                    </div>
                                                                    <div className='p-2 d-flex justify-content-center align-items-center flex-column' style={{ flexGrow: 1 }}>
                                                                        <h6>{item.naam}</h6>
                                                                        <div className="hp_red" data-tooltip-id={`hp-${item.id}`} data-tooltip-content={`${item.leven}/${item.levenmax}`} style={{ height: "2px", width: "86%" }}>
                                                                            <div className="progress" style={{ width: `${item.leven * 100 / item.levenmax}%` }}></div>
                                                                            <Tooltip id={`hp-${item.id}`} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    })}
                                            </div>

                                        </div>}
                                        {type == 'Fugir' && <div>
                                            <div className="ar_battle_bottom_bottm">
                                                {attackList.length === 0 && (
                                                    <div className="text-center text-white p-3">
                                                        <p>{t('No attacks available')}</p>
                                                </div>
                                                )}
                                                {attackList.map((item, index) => {
                                                    return <div key={index} className="ar_battle_single_bottom" onClick={() => attack(item)}>
                                                        <a href="#">
                                                            <img 
                                                                src={`/images/battle/${getAttackTypeImage(item.type)}`} 
                                                                alt="images" 
                                                                onError={(e) => {
                                                                    e.target.onerror = null;
                                                                    e.target.src = '/images/battle/Normal.png';
                                                                }}
                                                            />
                                                        </a>
                                                        <p>{item.name}</p>
                                                    </div>
                                                })}
                                            </div>
                                        </div>}
                                        {type == 'Mochila' && <div className='d-flex flex-wrap justify-content-start gap-2 p-3'>
                                            {loadingPokeballs ? (
                                                <div className='w-100 text-center'>{t('Loading items...')}</div>
                                            ) : allItems.length > 0 ? (
                                                allItems.map((item, index) => {
                                                    const isPokeball = item.wat === 'pokeball' || item.name.toLowerCase().includes('ball');
                                                    const isPotion = item.wat === 'potion' || item.name.toLowerCase().includes('potion') || item.name.toLowerCase().includes('heal') || item.name.toLowerCase().includes('revive');
                                                    
                                                    // בקרבות מאמן, הפוקדורים לא זמינים
                                                    const isPokeballDisabled = isPokeball && isTrainerBattle;
                                                    
                                                    return (
                                                        <div 
                                                            key={index} 
                                                            className='p-2 mochila-items position-relative cursor-pointer'
                                                            style={{ 
                                                                cursor: (oppAttacking || !isPlayerTurn || isPokeballDisabled) ? 'not-allowed' : 'pointer',
                                                                opacity: (oppAttacking || !isPlayerTurn || isPokeballDisabled) ? 0.3 : 1
                                                            }}
                                                            onClick={() => {
                                                                if (oppAttacking || !isPlayerTurn) {
                                                                    toast.warning(t('Cannot use items during opponent\'s turn!'));
                                                                    return;
                                                                }
                                                                
                                                                if (isPokeball) {
                                                                    if (isTrainerBattle) {
                                                                        toast.error(t('Cannot catch trainer\'s Pokemon! They already have a trainer.'));
                                                                        return;
                                                                    }
                                                                    if (!isMapBattle) {
                                                                        toast.warning(t('Pokeballs can only be used in map battles!'));
                                                                        return;
                                                                    }
                                                                    handlePokeball(item);
                                                                } else if (isPotion) {
                                                                    // TODO: Implement potion usage
                                                                    toast.info(t('Potion usage coming soon!'));
                                                                } else {
                                                                    toast.info(t('Item usage coming soon!'));
                                                                }
                                                            }}
                                                            title={item.name}
                                                        >
                                                            <img 
                                                                src={getItemImage(item.name)} 
                                                                alt={item.name}
                                                                onError={(e) => {
                                                                    console.error("❌ Image failed to load:", getItemImage(item.name), "Item name:", item.name);
                                                                    e.target.onerror = null;
                                                                    e.target.src = getItemImage('Poke ball');
                                                                }}
                                                                onLoad={() => {
                                                                    console.log("✅ Image loaded successfully:", getItemImage(item.name));
                                                                }}
                                                            />
                                                            <Badge bg={isPokeball ? 'danger' : isPotion ? 'success' : 'secondary'}>{item.amount}</Badge>
                                                        </div>
                                                    );
                                                })
                                            ) : (
                                                <div className='w-100 text-center'>{t('No items in your backpack!')}</div>
                                            )}
                                        </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* כפתור חזרה למפה בקרבות מפה */}
                    {isMapBattle && !winLose && (
                        <div className="return-to-map-button">
                            <Button 
                                variant="danger" 
                                onClick={tryNavigateToMap}
                                style={{ position: 'absolute', top: '10px', right: '10px', zIndex: 10 }}
                            >
                                {t('Return to Map')}
                            </Button>
                        </div>
                    )}
                </section>
            </GoldSiverHeader>
            
            {/* Evolution Modal */}
            {evolutionData && (
                <>
                    <EvolutionAnimation
                        show={showEvolutionAnimation && showEvolutionModal}
                        oldPokemonImage={`/images/pokemon/${evolutionData.current_wild_id}.gif`}
                        newPokemonImage={`/images/pokemon/${evolutionData.evolved_wild_id}.gif`}
                        onComplete={() => {
                            // Animation completed, keep modal open for user to accept
                        }}
                    />
                    <Modal 
                        show={showEvolutionModal} 
                        onHide={() => setShowEvolutionModal(false)}
                        centered
                        size="lg"
                    >
                        <Modal.Header closeButton className="bg-dark text-white">
                            <Modal.Title>
                                🎉 {evolutionData.current_name} is Evolving!
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="bg-dark text-white text-center">
                            <div className="mb-4">
                                <h4>{evolutionData.current_name}</h4>
                                <div className="my-3">
                                    <span style={{ fontSize: '24px' }}>→</span>
                                </div>
                                <h4 className="text-success">{evolutionData.evolved_name}</h4>
                            </div>
                            <p className="text-muted">
                                Your {evolutionData.current_name} reached level {evolutionData.level} and is ready to evolve into {evolutionData.evolved_name}!
                            </p>
                            <div className="d-flex justify-content-center gap-3 mt-4">
                                <img 
                                    src={`/images/pokemon/${evolutionData.current_wild_id}.gif`}
                                    alt={evolutionData.current_name}
                                    style={{ maxWidth: '150px', imageRendering: 'pixelated' }}
                                    onError={(e) => {
                                        e.target.src = '/images/pokemon/1.gif';
                                    }}
                                />
                                <span style={{ fontSize: '32px', alignSelf: 'center' }}>→</span>
                                <img 
                                    src={`/images/pokemon/${evolutionData.evolved_wild_id}.gif`}
                                    alt={evolutionData.evolved_name}
                                    style={{ maxWidth: '150px', imageRendering: 'pixelated' }}
                                    onError={(e) => {
                                        e.target.src = '/images/pokemon/1.gif';
                                    }}
                                />
                            </div>
                        </Modal.Body>
                        <Modal.Footer className="bg-dark">
                            <Button 
                                variant="secondary" 
                                onClick={() => {
                                    setShowEvolutionModal(false);
                                    setShowEvolutionAnimation(false);
                                    setEvolutionData(null);
                                }}
                            >
                                Close
                            </Button>
                            <Button 
                                variant="success" 
                                onClick={async () => {
                                    try {
                                        console.log('Evolution data being sent:', {
                                            pokemon_id: evolutionData.pokemon_id,
                                            evolved_wild_id: evolutionData.evolved_wild_id
                                        });
                                        
                                        const response = await axiosInstance.post(API_ENDPOINTS.ACCEPT_EVOLUTION, {
                                            pokemon_id: evolutionData.pokemon_id,
                                            evolved_wild_id: evolutionData.evolved_wild_id
                                        });
                                        
                                        console.log('Evolution response:', response.data);
                                        
                                        if (response.data && response.data.status === 'success') {
                                            toast.success(`${evolutionData.current_name} evolved into ${evolutionData.evolved_name}!`);
                                            
                                            // Refresh Pokemon data
                                            await dispatch(getPlayerPokemons()).then((result) => {
                                                if (result.payload && Array.isArray(result.payload)) {
                                                    const evolvedPokemon = result.payload.find(p => p.id === evolutionData.pokemon_id);
                                                    if (evolvedPokemon) {
                                                        // Update current Pokemon if it's the one that evolved
                                                        if (yourPokemon?.id === evolutionData.pokemon_id) {
                                                            setYourPokemon(evolvedPokemon);
                                                        }
                                                        // Update in battle pokemons list
                                                        setBattlePokemons(prev => prev.map(p => 
                                                            p.id === evolvedPokemon.id ? evolvedPokemon : p
                                                        ));
                                                    }
                                                }
                                            });
                                            
                                            setShowEvolutionModal(false);
                                            setShowEvolutionAnimation(false);
                                            setEvolutionData(null);
                                        } else {
                                            const errorMsg = response.data?.message || response.data?.error || 'Failed to evolve Pokemon';
                                            console.error('Evolution failed:', response.data);
                                            toast.error(errorMsg);
                                        }
                                    } catch (error) {
                                        console.error('Error accepting evolution:', error);
                                        const errorMsg = error?.response?.data?.message || error?.response?.data?.error || error?.message || 'Failed to evolve Pokemon';
                                        console.error('Full error response:', error?.response?.data);
                                        toast.error(errorMsg);
                                    }
                                }}
                            >
                                Evolve!
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    
                    {/* Learn New Attack Modal */}
                    <LearnAttackModal
                        show={showLearnAttackModal}
                        onHide={() => {
                            setShowLearnAttackModal(false);
                            setPendingAttackData(null);
                            localStorage.removeItem('pendingAttackData');
                        }}
                        pendingAttackData={pendingAttackData}
                        onAttackLearned={() => {
                            // Refresh Pokemon data
                            dispatch(getPlayerPokemons());
                            setShowLearnAttackModal(false);
                            setPendingAttackData(null);
                            localStorage.removeItem('pendingAttackData');
                        }}
                    />
                </>
            )}
        </>

    )
}

export default Battle